// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useZone } from "../../context/ZoneContext";
// import VillaCard from "../villacard/VillaCard";
// import useMobileTouch from "./mopile/useMopileTouch";
// import { useRangeFilter } from "../../context/rangeFilterContext";
// import UnitsSvg from "./svg/unitSvg";
// import { useTabsFilter } from "../../context/TabsFilterContext";
// import { useSearchParams } from "react-router-dom";

// import { useFilterContext } from "../../context/FilterContext";
// function MasterPlaneInner({
//   setProgressVilla,
//   setSpinVilla,
//   filterSelection,
//   isOverlayHidden,
//   lang,

// }) {

//   const { filteredUnits, searchText } = useFilterContext();
//   const { filters } = useRangeFilter();
//   const { units = [], project: projectData } = useZone();
//   const clickableLayerSvgString = projectData?.clickable_layer || null;
//   const { activeTab } = useTabsFilter();
//   const [searchParams, setSearchParams] = useSearchParams();

//   const unitsSvgRef = useRef(null);

//   // ------------------------------------------------------------------
//   // Tiles Map (background images)
//   // ------------------------------------------------------------------
//   const tilesMap = useMemo(() => {
//     if (!projectData?.building_images) return {};

//     const map = {};
//     projectData.building_images.forEach((item) => {
//       const match = item.image.match(/tile_(\d+)_(\d+)\.jpg$/);
//       if (match) {
//         const col = match[1];
//         const row = match[2];
//         map[`${col}-${row}`] = item.image;
//       }
//     });
//     return map;
//   }, [projectData]);

//   // ------------------------------------------------------------------
//   // Constants
//   // ------------------------------------------------------------------
//   const rows = 32;
//   const cols = 32;
//   const tileSize = 512;

//   const mapWidth = cols * tileSize;
//   const mapHeight = rows * tileSize;
//   const viewBoxWidth = 1638.4;
//   const viewBoxHeight = 1638.4;

//   // ------------------------------------------------------------------
//   // State
//   // ------------------------------------------------------------------
//   const [zoom, setZoom] = useState(1);
//   const [dragging, setDragging] = useState(false);
//   const [selectedVilla, setSelectedVilla] = useState(null);
//   const [hoveredVilla, setHoveredVilla] = useState(null);
//   const [minZoom, setMinZoom] = useState(1);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [velocity, setVelocity] = useState({ x: 0, y: 0 });
//   const [lastPos, setLastPos] = useState({ x: 0, y: 0 });
//   const [loadedTiles, setLoadedTiles] = useState(new Set());
//   const didDebugFromUrl = useRef(false);

//   const initialZoom = Math.max(
//     window.innerWidth / mapWidth,
//     window.innerHeight / mapHeight,
//   );

//   const [pos, setPos] = useState({
//     x: (window.innerWidth - mapWidth * initialZoom) / 2,
//     y: (window.innerHeight - mapHeight * initialZoom) / 2,
//   });
//   // إنشاء Ref لتخزين tiles محمّلة مسبقًا
//   const loadedTilesRef = useRef(new Set());

//   // نحسب الـtiles الظاهرة + caching
//   const cachedVisibleTiles = useMemo(() => {
//     const tiles = [];
//     const buffer = 1; // tiles إضافية حول الشاشة

//     const startRow = Math.max(
//       0,
//       Math.floor(-pos.y / (tileSize * zoom)) - buffer,
//     );
//     const endRow = Math.min(
//       rows,
//       Math.ceil((window.innerHeight - pos.y) / (tileSize * zoom)) + buffer,
//     );
//     const startCol = Math.max(
//       0,
//       Math.floor(-pos.x / (tileSize * zoom)) - buffer,
//     );
//     const endCol = Math.min(
//       cols,
//       Math.ceil((window.innerWidth - pos.x) / (tileSize * zoom)) + buffer,
//     );

//     for (let row = startRow; row < endRow; row++) {
//       for (let col = startCol; col < endCol; col++) {
//         const tileKey = `${col}-${row}`;
//         const imagePath = tilesMap[tileKey];

//         if (!imagePath) continue;

//         // لو Tile جديد، أضفها للـcache
//         if (!loadedTilesRef.current.has(tileKey)) {
//           loadedTilesRef.current.add(tileKey);
//         }

//         tiles.push({ tileKey, row, col, imagePath });
//       }
//     }

//     return tiles;
//   }, [pos.x, pos.y, zoom, tilesMap]);
//   // Ref لتخزين الصور الفعلية
//   // const imageCacheRef = useRef({});

//   // // Preload الصور قبل render
//   // useEffect(() => {
//   //   cachedVisibleTiles.forEach(({ tileKey, imagePath }) => {
//   //     if (!imageCacheRef.current[tileKey]) {
//   //       const img = new Image();
//   //       img.src = `https://api.gravity-proptech.com/public/storage/${imagePath}`;
//   //       imageCacheRef.current[tileKey] = img;
//   //     }
//   //   });
//   // }, [cachedVisibleTiles, lang]);
//   // ------------------------------------------------------------------
//   // Initial setup & resize handling
//   // ------------------------------------------------------------------
//   const calculateInitialView = () => {
//     const currentWidth = window.innerWidth;
//     const currentHeight = window.innerHeight;
//     const newMinZoom = Math.max(
//       currentWidth / mapWidth,
//       currentHeight / mapHeight,
//     );

//     setMinZoom(newMinZoom);

//     setZoom((prevZoom) => {
//       const targetZoom = Math.max(prevZoom, newMinZoom);

//       setPos((prevPos) => {
//         let newX, newY;
//         const scaledWidth = mapWidth * targetZoom;
//         const scaledHeight = mapHeight * targetZoom;

//         if (selectedVilla) {
//           const villaScreenX =
//             selectedVilla.center.x * targetZoom * (mapWidth / viewBoxWidth);
//           const villaScreenY =
//             selectedVilla.center.y * targetZoom * (mapHeight / viewBoxHeight);

//           const centerX = currentWidth / 2;
//           const centerY = currentHeight / 1.1;
//           // const centerX = currentWidth / 2;
//           // const centerY = currentHeight / 1.5;

//           newX = centerX - villaScreenX;
//           newY = centerY - villaScreenY;
//         } else {
//           const centerMapX = (currentWidth / 2 - prevPos.x) / prevZoom;
//           const centerMapY = (currentHeight / 2 - prevPos.y) / prevZoom;

//           newX = currentWidth / 2 - centerMapX * targetZoom;
//           newY = currentHeight / 2 - centerMapY * targetZoom;
//         }

//         // Clamp
//         const maxX = 0;
//         const maxY = 0;
//         const minX =
//           scaledWidth < currentWidth
//             ? (currentWidth - scaledWidth) / 2
//             : -scaledWidth + currentWidth;
//         const minY =
//           scaledHeight < currentHeight
//             ? (currentHeight - scaledHeight) / 2
//             : -scaledHeight + currentHeight;

//         newX = Math.max(Math.min(newX, maxX), minX);
//         newY = Math.max(Math.min(newY, maxY), minY);

//         return { x: newX, y: newY };
//       });

//       return targetZoom;
//     });
//   };

//   useEffect(() => {
//     const newMinZoom = Math.max(
//       window.innerWidth / mapWidth,
//       window.innerHeight / mapHeight,
//     );

//     setMinZoom(newMinZoom);
//     setZoom(newMinZoom);
//     setPos({
//       x: (window.innerWidth - mapWidth * newMinZoom) / 2,
//       y: (window.innerHeight - mapHeight * newMinZoom) / 2,
//     });
//   }, []);

//   // ------------------------------------------------------------------
//   // Mouse drag handlers
//   // ------------------------------------------------------------------
//   const onMouseDown = (e) => {
//     setDragging(true);
//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: 0, y: 0 });
//   };

//   const onMouseMove = (e) => {
//     if (!dragging) return;

//     const dx = e.clientX - lastPos.x;
//     const dy = e.clientY - lastPos.y;

//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: dx / 16, y: dy / 16 });

//     setPos((prev) => {
//       const scaledWidth = mapWidth * zoom;
//       const scaledHeight = mapHeight * zoom;
//       const maxX = 0;
//       const maxY = 0;
//       const minX =
//         scaledWidth < window.innerWidth
//           ? (window.innerWidth - scaledWidth) / 2
//           : -scaledWidth + window.innerWidth;
//       const minY =
//         scaledHeight < window.innerHeight
//           ? (window.innerHeight - scaledHeight) / 2
//           : -scaledHeight + window.innerHeight;

//       let newX = prev.x + dx;
//       let newY = prev.y + dy;

//       return {
//         x: Math.max(Math.min(newX, maxX), minX),
//         y: Math.max(Math.min(newY, maxY), minY),
//       };
//     });
//   };

//   const onMouseUp = () => {
//     if (!dragging) return;
//     setDragging(false);

//     let vx = velocity.x * 0.5;
//     let vy = velocity.y * 0.5;
//     const decay = 0.75;
//     const speedFactor = 15;

//     const animate = () => {
//       setPos((prev) => {
//         const scaledWidth = mapWidth * zoom;
//         const scaledHeight = mapHeight * zoom;
//         const maxX = 0;
//         const maxY = 0;
//         const minX =
//           scaledWidth < window.innerWidth
//             ? (window.innerWidth - scaledWidth) / 2
//             : -scaledWidth + window.innerWidth;
//         const minY =
//           scaledHeight < window.innerHeight
//             ? (window.innerHeight - scaledHeight) / 2
//             : -scaledHeight + window.innerHeight;

//         let newX = prev.x + vx * speedFactor;
//         let newY = prev.y + vy * speedFactor;

//         if (newX >= maxX || newX <= minX) vx = 0;
//         if (newY >= maxY || newY <= minY) vy = 0;

//         newX = Math.max(Math.min(newX, maxX), minX);
//         newY = Math.max(Math.min(newY, maxY), minY);

//         return { x: newX, y: newY };
//       });

//       vx *= decay;
//       vy *= decay;

//       if (Math.abs(vx) > 0.01 || Math.abs(vy) > 0.01) {
//         requestAnimationFrame(animate);
//       }
//     };

//     requestAnimationFrame(animate);
//   };

//   // ------------------------------------------------------------------
//   // 1. Resize Effect (النسخة النهائية اللي بتحل مشكلة الـ Reset)
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const handleResize = () => {
//       const vw = window.innerWidth;
//       const vh = window.innerHeight;

//       // حساب الحد الأدنى الجديد دايماً
//       const newMinZoom = Math.max(vw / mapWidth, vh / mapHeight);
//       setMinZoom(newMinZoom);

//       if (selectedVilla) {
//         // حالة (أ): فيه فيلا -> "ثبت الزوم" وحرك الماب بس عشان الفيلا تفضل في مكانها
//         setPos(() => {
//           const villaX =
//             selectedVilla.center.x * zoom * (mapWidth / viewBoxWidth);
//           const villaY =
//             selectedVilla.center.y * zoom * (mapHeight / viewBoxHeight);

//           let newX = vw / 2 - villaX;
//           let newY = vh / 1.5 - villaY;

//           const scaledW = mapWidth * zoom;
//           const scaledH = mapHeight * zoom;
//           const minX = vw - scaledW;
//           const minY = vh - scaledH;

//           newX =
//             scaledW < vw
//               ? (vw - scaledW) / 2
//               : Math.max(Math.min(newX, 0), minX);
//           newY =
//             scaledH < vh
//               ? (vh - scaledH) / 2
//               : Math.max(Math.min(newY, 0), minY);

//           return { x: newX, y: newY };
//         });
//       } else {
//         // حالة (ب): مفيش فيلا -> "ارجع للأصل" (Reset)
//         // ده السطر اللي هيخلي الزوم يرجع يملأ الشاشة أول ما تغيري حجمها ومفيش فيلا
//         setZoom(newMinZoom);

//         setPos({
//           x: (vw - mapWidth * newMinZoom) / 2,
//           y: (vh - mapHeight * newMinZoom) / 2,
//         });
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [selectedVilla, zoom, mapWidth, mapHeight]);
//   // ------------------------------------------------------------------
//   // 2. Wheel Zoom Effect (Works when not resizing)
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const el = document.getElementById("map-container");
//     if (!el) return;

//     const handleWheel = (e) => {
//       e.preventDefault();
//       const scaleAmount = e.deltaY < 0 ? 1.1 : 0.9;
//       let newZoom = zoom * scaleAmount;

//       // الالتزام بـ minZoom المحسوب في الـ resize لمنع الفراغ الأبيض
//       newZoom = Math.max(Math.min(newZoom, 2), minZoom);

//       const rect = el.getBoundingClientRect();
//       const mouseX = e.clientX - rect.left;
//       const mouseY = e.clientY - rect.top;

//       const zoomRatio = newZoom / zoom;
//       let newX = mouseX - (mouseX - pos.x) * zoomRatio;
//       let newY = mouseY - (mouseY - pos.y) * zoomRatio;

//       // منع الخروج عن الحدود أثناء الزوم
//       const scaledW = mapWidth * newZoom;
//       const scaledH = mapHeight * newZoom;
//       const minX = window.innerWidth - scaledW;
//       const minY = window.innerHeight - scaledH;

//       // إذا كانت الماب أصغر من الشاشة (مستحيل عملياً بسبب minZoom) يتم التوسيط، غير ذلك يتم التقييد
//       newX =
//         scaledW < window.innerWidth
//           ? (window.innerWidth - scaledW) / 2
//           : Math.max(Math.min(newX, 0), minX);
//       newY =
//         scaledH < window.innerHeight
//           ? (window.innerHeight - scaledH) / 2
//           : Math.max(Math.min(newY, 0), minY);

//       setZoom(newZoom);
//       setPos({ x: newX, y: newY });
//     };

//     el.addEventListener("wheel", handleWheel, { passive: false });
//     return () => el.removeEventListener("wheel", handleWheel);
//   }, [zoom, pos, minZoom, mapWidth, mapHeight]);

//   // ------------------------------------------------------------------
//   // Villa interaction handlers
//   // ------------------------------------------------------------------

//   const handleVillaMouseEnter = (villaId) => {
//     setHoveredVilla(villaId);
//   };
//   const handleVillaMouseLeave = () => {
//     setHoveredVilla(null);
//   };
//   // const handleMapClick = (e) => {
//   //   if (e.target.tagName !== "path") {
//   //     setSelectedVilla(null);
//   //     // setSearchParams({});
//   //   }
//   // };
//   const handleMapClick = (e) => {
//     // التأكد أن الضغطة ليست على مسار SVG (فيلا) وليست داخل الكارد
//     if (e.target.tagName !== "path" && !e.target.closest(".base-card-unit-")) {
//       // setSelectedVilla(null);
//       setSearchParams({}, { replace: true }); // مسح الـ URL بأمان
//       didDebugFromUrl.current = false; // اسمحي له يقرأ من الـ URL تاني لو اليوزر اختار فيلا جديدة
//     }
//   };
//   // ------------------------------------------------------------------
//   // Mobile touch hook
//   // ------------------------------------------------------------------
//   const { onTouchStart, onTouchMove, onTouchEnd, onTouchCancel } =
//     useMobileTouch({
//       mapWidth,
//       mapHeight,
//       zoom,
//       setZoom,
//       setPos,
//       setDragging,
//       setVelocity,
//       dragging,
//       lastPos,
//       setLastPos,
//       velocity,
//       minZoom: 0.5,
//       maxZoom: 2,
//     });
//   const focusOnVilla = (villa) => {
//     const fullVillaData = units.find((u) => u.code === villa.code);

//     setSelectedVilla({ ...villa, ...(fullVillaData || {}) });
//     setIsAnimating(true);

//     // زوم مناسب لرؤية التفاصيل والكارد
//     const targetZoom = 0.8;

//     const villaX = villa.center.x * targetZoom * (mapWidth / viewBoxWidth);
//     const villaY = villa.center.y * targetZoom * (mapHeight / viewBoxHeight);

//     const screenCenterX = window.innerWidth / 2;
//     // جعل الفيلا تظهر عند 75% من ارتفاع الشاشة (يعني نازلة لتحت)
//     const screenTargetY = window.innerHeight * 0.75;

//     let newX = screenCenterX - villaX;
//     let newY = screenTargetY - villaY;

//     const scaledW = mapWidth * targetZoom;
//     const scaledH = mapHeight * targetZoom;

//     // --- تعديل القيود (الـ Clamp) لفك القفل العلوي ---
//     const maxX = 0;
//     const maxY = 500; // السماح للماب بالنزول لأسفل بمقدار 500 بكسل
//     const minX = window.innerWidth - scaledW;
//     const minY = window.innerHeight - scaledH;

//     // تطبيق القيود الجديدة
//     newX = Math.max(Math.min(newX, maxX), minX);
//     newY = Math.max(Math.min(newY, maxY), minY);

//     const duration = 800;
//     const startTime = performance.now();
//     const startZoom = zoom;
//     const startX = pos.x;
//     const startY = pos.y;

//     const animate = (time) => {
//       const progress = Math.min((time - startTime) / duration, 1);
//       const ease = 1 - Math.pow(1 - progress, 3);

//       setZoom(startZoom + (targetZoom - startZoom) * ease);
//       setPos({
//         x: startX + (newX - startX) * ease,
//         y: startY + (newY - startY) * ease,
//       });

//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       } else {
//         setIsAnimating(false);
//       }
//     };

//     requestAnimationFrame(animate);
//   };

//   useEffect(() => {
//     const unitCode = searchParams.get("unit");

//     // 1. لو الـ URL اتمسح خالص، اقفلي الكارد فوراً
//     if (!unitCode) {
//       setSelectedVilla(null);
//       return;
//     }

//     // 2. لو فيه كود في الـ URL
//     if (units.length > 0) {
//       // التعديل السحري: لو الكود اللي في الـ URL مختلف عن اللي في الـ State
//       // حدثي الـ State فوراً بالبيانات الجديدة قبل ما يبدأ الأنميشن
//       if (selectedVilla?.code !== unitCode) {
//         const villa = units.find((u) => u.code === unitCode);
//         if (villa) {
//           const center =
//             villa.center || unitsSvgRef.current?.getCenterByCode(villa.code);

//           if (center) {
//             // تحديث الداتا فوراً لمنع ظهور الفيلا القديمة
//             setSelectedVilla({ ...villa });
//             // بدأ الفوكس والأنميشن
//             focusOnVilla({ ...villa, center });
//           }
//         }
//       }
//     }
//   }, [searchParams, units]); // شيلنا selectedVilla.code من هنا عشان نمنع الـ Loop

//   useEffect(() => {
//     // بنشغل المنطق ده فقط لو المستخدم كاتب نص فعلاً في السيرش
//     if (searchText.trim() !== "" && filteredUnits.length === 1) {
//       const targetUnit = filteredUnits[0];

//       // لو الفيلا اللي ظهرت حالياً مختلفة عن اللي كانت مختارة قبل كده
//       if (selectedVilla?.code !== targetUnit.code) {
//         const center = unitsSvgRef.current?.getCenterByCode(targetUnit.code);

//         if (center) {
//           // 1. تحديث الـ URL فوراً
//           setSearchParams({ unit: targetUnit.code }, { replace: true });

//           // 2. عمل الأنميشن والفوكس
//           focusOnVilla({ ...targetUnit, center });
//         }
//       }
//     }
//   }, [filteredUnits, searchText, focusOnVilla, setSearchParams, selectedVilla]);

//   const handleVillaClick = (villa) => {
//     if (!villa || !villa.center) return;

//     setSearchParams({ unit: villa.code });
//     focusOnVilla(villa);
//   };
// // 1. تأكدي إن الكود ده موجود جوه الكومبوننت
// const visibleTileKeys = useMemo(() => {
//   const keys = new Set();
//   const buffer = 1;

//   const startRow = Math.max(0, Math.floor(-pos.y / (tileSize * zoom)) - buffer);
//   const endRow = Math.min(rows, Math.ceil((window.innerHeight - pos.y) / (tileSize * zoom)) + buffer);
//   const startCol = Math.max(0, Math.floor(-pos.x / (tileSize * zoom)) - buffer);
//   const endCol = Math.min(cols, Math.ceil((window.innerWidth - pos.x) / (tileSize * zoom)) + buffer);

//   for (let row = startRow; row < endRow; row++) {
//     for (let col = startCol; col < endCol; col++) {
//       keys.add(`${col}-${row}`);
//     }
//   }
//   return keys;
// }, [pos.x, pos.y, zoom]); // الحساب هنا سريع جداً لأنه أرقام بس

// const canvasRef = useRef(null);
// const workerRef = useRef(null);
// // هذا المرجع سيحتفظ بحالة النقل حتى لو أعيد رندر الكومبوننت
// const hasTransferred = useRef(false);

// useEffect(() => {
//   console.log("%c[Main] Effect Started", "color: yellow");

//   if (canvasRef.current && !hasTransferred.current) {
//     try {
//       // التأكد من المسار
//       const worker = new Worker('/mapWorker.js');
//       workerRef.current = worker;

//       // اختبار استقبال رسائل من الـ Worker
//       worker.onmessage = (e) => {
//         console.log("%c[Main] Message FROM Worker:", "color: #00ff00", e.data);
//       };

//       const offscreen = canvasRef.current.transferControlToOffscreen();

//       worker.postMessage({
//         type: 'INIT',
//         data: {
//           canvas: offscreen,
//           width: window.innerWidth,
//           height: window.innerHeight
//         }
//       }, [offscreen]);

//       hasTransferred.current = true;
//       console.log("[Main] INIT sent");

//     } catch (err) {
//       console.error("[Main] Setup Error:", err);
//     }
//   }

//   // شيلنا الـ worker.terminate() مؤقتاً عشان نتأكد إنه مش بيموت بسبب الـ Strict Mode
//   return () => {
//     console.log("%c[Main] Cleanup Called (Not terminating for debug)", "color: orange");
//   };
// }, []);

// // --- الجزء الناقص اللي هيشغل الصور ---
// useEffect(() => {
//   // التأكد إن الـ Worker شغال وفيه صور فعلاً محسوبة
//   if (workerRef.current && cachedVisibleTiles.length > 0) {

//     // إرسال البيانات للـ Worker
//     workerRef.current.postMessage({
//       type: 'RENDER',
//       data: {
//         pos,
//         zoom,
//         visibleTiles: cachedVisibleTiles
//       }
//     });
//   }
// }, [pos, zoom, cachedVisibleTiles]); // كل ما يتحرك الماوس أو تعملي زوم، هيبعت للـ Worker يرسم

//   // ------------------------------------------------------------------
//   // Render
//   // ------------------------------------------------------------------
//   return (
//     <div
//       id="map-container"
//       dir="ltr"
//       style={{
//         width: "100vw",
//         height: "100vh",
//         overflow: "hidden",
//         position: "relative",
//         cursor: dragging ? "grabbing" : "grab",
//         userSelect: "none",
//         touchAction: "none",
//       }}
//       onMouseDown={onMouseDown}
//       onMouseMove={onMouseMove}
//       onMouseUp={onMouseUp}
//       onMouseLeave={onMouseUp}
//       onTouchStart={onTouchStart}
//       onTouchMove={onTouchMove}
//       onTouchEnd={onTouchEnd}
//       onTouchCancel={onTouchCancel}
//       onClick={handleMapClick}
//     >
//       {/* <div
//         style={{
//           transform: `translate(${pos.x}px, ${pos.y}px) scale(${zoom})`,
//           transformOrigin: "top left",
//           willChange: "transform",
//           width: mapWidth,
//           height: mapHeight,
//         }}
//       >
//         {cachedVisibleTiles.map(({ tileKey, row, col }) => {
//           const img = imageCacheRef.current[tileKey];
//           if (!img) return null;
//           return (
//             <img
//               key={tileKey}
//               src={img.src}
//               alt=""
//               width={tileSize}
//               height={tileSize}
//               draggable="false"
//               style={{
//                 position: "absolute",
//                 left: col * tileSize,
//                 top: row * tileSize,
//                 // --- الإضافات الجديدة ---
//                 // imageRendering: "crisp-edges", // أو 'pixelated' لو الصور خرائط دقيقة
//                 // WebkitBackfaceVisibility: "hidden", // لمنع الرعشة أثناء الزوم
//                 // transform: "translateZ(0)", // إجبار المتصفح على استخدام كارت الشاشة GPU
//               }}
//             />
//           );
//         })}
//       </div> */}
// {/* /* --- استبدلي جزء عرض الصور في الـ return بهذا الكود --- */ }
// <canvas
//   ref={canvasRef}
//   width={window.innerWidth}
//   height={window.innerHeight}
//   style={{
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     pointerEvents: 'none', // مهم جداً لكي لا يمنع الضغط على الـ SVGs
//     zIndex: 1
//   }}
// />
// {/* <div
//   style={{
//     transform: `translate(${pos.x}px, ${pos.y}px) scale(${zoom})`,
//     transformOrigin: "top left",
//     willChange: "transform",
//     width: mapWidth,
//     height: mapHeight,
//   }}
// >
//   {Object.entries(tilesMap).map(([tileKey, imagePath]) => {
//     const [col, row] = tileKey.split("-").map(Number);
//     return (
//       <img
//         key={tileKey}
//         src={`https://api.gravity-proptech.com/public/storage/${imagePath}`}
//         alt=""
//         width={tileSize}
//         height={tileSize}
//         draggable="false"
//         loading="lazy"
//         style={{
//           position: "absolute",
//           left: col * tileSize,
//           top: row * tileSize,
//           WebkitBackfaceVisibility: "hidden",
//           transform: "translateZ(0)",
//           imageRendering: "pixelated",
//           display: "block",
//         }}
//       />
//     );
//   })}
// </div> */}
//       {/* Overlay SVGs */}
//       <div
//         style={{
//           position: "absolute",
//           left: pos.x,
//           top: pos.y,
//           width: mapWidth,
//           height: mapHeight,
//           transform: `scale(${zoom})`,
//           transformOrigin: "top left",
//           zIndex: 99,
//         }}
//       >
//         {!isOverlayHidden && (
//           <UnitsSvg
//             ref={unitsSvgRef}
//             mapWidth={mapWidth}
//             mapHeight={mapHeight}
//             clickableLayer={clickableLayerSvgString}
//             units={units}
//             hoveredVilla={hoveredVilla}
//             selectedVilla={selectedVilla}
//             onMouseEnter={handleVillaMouseEnter}
//             onMouseLeave={handleVillaMouseLeave}
//             onVillaClick={handleVillaClick}
//             activeTab={activeTab}
//             cancelledTypes={filterSelection?.cancelledTypes || []}
//             cancelledAvailability={filterSelection?.cancelledAvailability || []}
//             progressCategories={filterSelection?.progressCategories || []}
//             filters={filters}

//   bookingDate={filterSelection?.booking_date}
//           />
//         )}
//       </div>

//       {/* Selected villa card */}
//       {selectedVilla && !isAnimating && (
//         <div
//           style={{
//             position: "fixed",
//             left:
//               pos.x + selectedVilla.center.x * zoom * (mapWidth / viewBoxWidth),
//             top:
//               pos.y +
//               selectedVilla.center.y * zoom * (mapHeight / viewBoxHeight),
//             zIndex: 99999,
//             transform: "translate(-50%, -110%)",
//           }}
//         >
//           <VillaCard
//             lang={lang}
//             page="master-plan"
//             width="340px"
//             villa={selectedVilla}
//             onShowProgress={setProgressVilla}
//             onOpenModal={() => {
//               setSpinVilla(selectedVilla);
//             }}
//           />
//         </div>
//       )}
//     </div>
//   );
// }

// function MasterPlane({
//   lang,
//   filterSelection,
//   isOverlayHidden,
//   filters,
//   setProgressVilla,
//   setSpinVilla,
//   projectSlug
// }) {
//   return (
//     <MasterPlaneInner
//     projectSlug={projectSlug}
//       filterSelection={filterSelection}
//       isOverlayHidden={isOverlayHidden}
//       filters={filters}
//       lang={lang}
//       setProgressVilla={setProgressVilla}
//       setSpinVilla={setSpinVilla}
//     />
//   );
// }

// export default MasterPlane;

// 26/3
// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useZone } from "../../context/ZoneContext";
// import VillaCard from "../villacard/VillaCard";
// import useMobileTouch from "./mopile/useMopileTouch";
// import { useRangeFilter } from "../../context/rangeFilterContext";
// import UnitsSvg from "./svg/unitSvg";
// import { useTabsFilter } from "../../context/TabsFilterContext";
// import { useSearchParams } from "react-router-dom";

// import { useFilterContext } from "../../context/FilterContext";
// function MasterPlaneInner({
//   setProgressVilla,
//   setSpinVilla,
//   filterSelection,
//   isOverlayHidden,
//   lang,
// }) {
//   const { filteredUnits, searchText } = useFilterContext();
//   const { filters } = useRangeFilter();
//   const { units = [], project: projectData } = useZone();
//   const clickableLayerSvgString = projectData?.clickable_layer || null;
//   const { activeTab } = useTabsFilter();
//   const [searchParams, setSearchParams] = useSearchParams();

//   const unitsSvgRef = useRef(null);

//   // ------------------------------------------------------------------
//   // Tiles Map (background images)
//   // ------------------------------------------------------------------
//   const tilesMap = useMemo(() => {
//     if (!projectData?.building_images) return {};

//     const map = {};
//     projectData.building_images.forEach((item) => {
//       const match = item.image.match(/tile_(\d+)_(\d+)\.jpg$/);
//       if (match) {
//         const col = match[1];
//         const row = match[2];
//         map[`${col}-${row}`] = item.image;
//       }
//     });
//     return map;
//   }, [projectData]);

//   // ------------------------------------------------------------------
//   // Constants
//   // ------------------------------------------------------------------
//   const rows = 32;
//   const cols = 32;
//   const tileSize = 512;

//   const mapWidth = cols * tileSize;
//   const mapHeight = rows * tileSize;
//   const viewBoxWidth = 1638.4;
//   const viewBoxHeight = 1638.4;

//   // ------------------------------------------------------------------
//   // State
//   // ------------------------------------------------------------------
//   const [zoom, setZoom] = useState(1);
//   const [dragging, setDragging] = useState(false);
//   const [selectedVilla, setSelectedVilla] = useState(null);
//   const [hoveredVilla, setHoveredVilla] = useState(null);
//   const [minZoom, setMinZoom] = useState(1);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [velocity, setVelocity] = useState({ x: 0, y: 0 });
//   const [lastPos, setLastPos] = useState({ x: 0, y: 0 });
//   const [loadedTiles, setLoadedTiles] = useState(new Set());
//   const didDebugFromUrl = useRef(false);

//   const initialZoom = Math.max(
//     window.innerWidth / mapWidth,
//     window.innerHeight / mapHeight,
//   );

//   const [pos, setPos] = useState({
//     x: (window.innerWidth - mapWidth * initialZoom) / 2,
//     y: (window.innerHeight - mapHeight * initialZoom) / 2,
//   });
//   // إنشاء Ref لتخزين tiles محمّلة مسبقًا
//   const loadedTilesRef = useRef(new Set());

//   // نحسب الـtiles الظاهرة + caching
//   const cachedVisibleTiles = useMemo(() => {
//     const tiles = [];
//     const buffer = 1; // tiles إضافية حول الشاشة

//     const startRow = Math.max(
//       0,
//       Math.floor(-pos.y / (tileSize * zoom)) - buffer,
//     );
//     const endRow = Math.min(
//       rows,
//       Math.ceil((window.innerHeight - pos.y) / (tileSize * zoom)) + buffer,
//     );
//     const startCol = Math.max(
//       0,
//       Math.floor(-pos.x / (tileSize * zoom)) - buffer,
//     );
//     const endCol = Math.min(
//       cols,
//       Math.ceil((window.innerWidth - pos.x) / (tileSize * zoom)) + buffer,
//     );

//     for (let row = startRow; row < endRow; row++) {
//       for (let col = startCol; col < endCol; col++) {
//         const tileKey = `${col}-${row}`;
//         const imagePath = tilesMap[tileKey];

//         if (!imagePath) continue;

//         // لو Tile جديد، أضفها للـcache
//         if (!loadedTilesRef.current.has(tileKey)) {
//           loadedTilesRef.current.add(tileKey);
//         }

//         tiles.push({ tileKey, row, col, imagePath });
//       }
//     }

//     return tiles;
//   }, [pos.x, pos.y, zoom, tilesMap]);
//   // Ref لتخزين الصور الفعلية
//   // const imageCacheRef = useRef({});

//   // // Preload الصور قبل render
//   // useEffect(() => {
//   //   cachedVisibleTiles.forEach(({ tileKey, imagePath }) => {
//   //     if (!imageCacheRef.current[tileKey]) {
//   //       const img = new Image();
//   //       img.src = `https://api.gravity-proptech.com/public/storage/${imagePath}`;
//   //       imageCacheRef.current[tileKey] = img;
//   //     }
//   //   });
//   // }, [cachedVisibleTiles, lang]);
//   // ------------------------------------------------------------------
//   // Initial setup & resize handling
//   // ------------------------------------------------------------------
//   const calculateInitialView = () => {
//     const currentWidth = window.innerWidth;
//     const currentHeight = window.innerHeight;
//     const newMinZoom = Math.max(
//       currentWidth / mapWidth,
//       currentHeight / mapHeight,
//     );

//     setMinZoom(newMinZoom);

//     setZoom((prevZoom) => {
//       const targetZoom = Math.max(prevZoom, newMinZoom);

//       setPos((prevPos) => {
//         let newX, newY;
//         const scaledWidth = mapWidth * targetZoom;
//         const scaledHeight = mapHeight * targetZoom;

//         if (selectedVilla) {
//           const villaScreenX =
//             selectedVilla.center.x * targetZoom * (mapWidth / viewBoxWidth);
//           const villaScreenY =
//             selectedVilla.center.y * targetZoom * (mapHeight / viewBoxHeight);

//           const centerX = currentWidth / 2;
//           const centerY = currentHeight / 1.1;
//           // const centerX = currentWidth / 2;
//           // const centerY = currentHeight / 1.5;

//           newX = centerX - villaScreenX;
//           newY = centerY - villaScreenY;
//         } else {
//           const centerMapX = (currentWidth / 2 - prevPos.x) / prevZoom;
//           const centerMapY = (currentHeight / 2 - prevPos.y) / prevZoom;

//           newX = currentWidth / 2 - centerMapX * targetZoom;
//           newY = currentHeight / 2 - centerMapY * targetZoom;
//         }

//         // Clamp
//         const maxX = 0;
//         const maxY = 0;
//         const minX =
//           scaledWidth < currentWidth
//             ? (currentWidth - scaledWidth) / 2
//             : -scaledWidth + currentWidth;
//         const minY =
//           scaledHeight < currentHeight
//             ? (currentHeight - scaledHeight) / 2
//             : -scaledHeight + currentHeight;

//         newX = Math.max(Math.min(newX, maxX), minX);
//         newY = Math.max(Math.min(newY, maxY), minY);

//         return { x: newX, y: newY };
//       });

//       return targetZoom;
//     });
//   };

//   useEffect(() => {
//     const newMinZoom = Math.max(
//       window.innerWidth / mapWidth,
//       window.innerHeight / mapHeight,
//     );

//     setMinZoom(newMinZoom);
//     setZoom(newMinZoom);
//     setPos({
//       x: (window.innerWidth - mapWidth * newMinZoom) / 2,
//       y: (window.innerHeight - mapHeight * newMinZoom) / 2,
//     });
//   }, []);

//   // ------------------------------------------------------------------
//   // Mouse drag handlers
//   // ------------------------------------------------------------------
//   const onMouseDown = (e) => {
//     setDragging(true);
//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: 0, y: 0 });
//   };

//   const onMouseMove = (e) => {
//     if (!dragging) return;

//     const dx = e.clientX - lastPos.x;
//     const dy = e.clientY - lastPos.y;

//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: dx / 16, y: dy / 16 });

//     setPos((prev) => {
//       const scaledWidth = mapWidth * zoom;
//       const scaledHeight = mapHeight * zoom;
//       const maxX = 0;
//       const maxY = 0;
//       const minX =
//         scaledWidth < window.innerWidth
//           ? (window.innerWidth - scaledWidth) / 2
//           : -scaledWidth + window.innerWidth;
//       const minY =
//         scaledHeight < window.innerHeight
//           ? (window.innerHeight - scaledHeight) / 2
//           : -scaledHeight + window.innerHeight;

//       let newX = prev.x + dx;
//       let newY = prev.y + dy;

//       return {
//         x: Math.max(Math.min(newX, maxX), minX),
//         y: Math.max(Math.min(newY, maxY), minY),
//       };
//     });
//   };

//   const onMouseUp = () => {
//     if (!dragging) return;
//     setDragging(false);

//     let vx = velocity.x * 0.5;
//     let vy = velocity.y * 0.5;
//     const decay = 0.75;
//     const speedFactor = 15;

//     const animate = () => {
//       setPos((prev) => {
//         const scaledWidth = mapWidth * zoom;
//         const scaledHeight = mapHeight * zoom;
//         const maxX = 0;
//         const maxY = 0;
//         const minX =
//           scaledWidth < window.innerWidth
//             ? (window.innerWidth - scaledWidth) / 2
//             : -scaledWidth + window.innerWidth;
//         const minY =
//           scaledHeight < window.innerHeight
//             ? (window.innerHeight - scaledHeight) / 2
//             : -scaledHeight + window.innerHeight;

//         let newX = prev.x + vx * speedFactor;
//         let newY = prev.y + vy * speedFactor;

//         if (newX >= maxX || newX <= minX) vx = 0;
//         if (newY >= maxY || newY <= minY) vy = 0;

//         newX = Math.max(Math.min(newX, maxX), minX);
//         newY = Math.max(Math.min(newY, maxY), minY);

//         return { x: newX, y: newY };
//       });

//       vx *= decay;
//       vy *= decay;

//       if (Math.abs(vx) > 0.01 || Math.abs(vy) > 0.01) {
//         requestAnimationFrame(animate);
//       }
//     };

//     requestAnimationFrame(animate);
//   };

//   // ------------------------------------------------------------------
//   // 1. Resize Effect (النسخة النهائية اللي بتحل مشكلة الـ Reset)
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const handleResize = () => {
//       const vw = window.innerWidth;
//       const vh = window.innerHeight;

//       // حساب الحد الأدنى الجديد دايماً
//       const newMinZoom = Math.max(vw / mapWidth, vh / mapHeight);
//       setMinZoom(newMinZoom);

//       if (selectedVilla) {
//         // حالة (أ): فيه فيلا -> "ثبت الزوم" وحرك الماب بس عشان الفيلا تفضل في مكانها
//         setPos(() => {
//           const villaX =
//             selectedVilla.center.x * zoom * (mapWidth / viewBoxWidth);
//           const villaY =
//             selectedVilla.center.y * zoom * (mapHeight / viewBoxHeight);

//           let newX = vw / 2 - villaX;
//           let newY = vh / 1.5 - villaY;

//           const scaledW = mapWidth * zoom;
//           const scaledH = mapHeight * zoom;
//           const minX = vw - scaledW;
//           const minY = vh - scaledH;

//           newX =
//             scaledW < vw
//               ? (vw - scaledW) / 2
//               : Math.max(Math.min(newX, 0), minX);
//           newY =
//             scaledH < vh
//               ? (vh - scaledH) / 2
//               : Math.max(Math.min(newY, 0), minY);

//           return { x: newX, y: newY };
//         });
//       } else {
//         // حالة (ب): مفيش فيلا -> "ارجع للأصل" (Reset)
//         // ده السطر اللي هيخلي الزوم يرجع يملأ الشاشة أول ما تغيري حجمها ومفيش فيلا
//         setZoom(newMinZoom);

//         setPos({
//           x: (vw - mapWidth * newMinZoom) / 2,
//           y: (vh - mapHeight * newMinZoom) / 2,
//         });
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [selectedVilla, zoom, mapWidth, mapHeight]);
//   // ------------------------------------------------------------------
//   // 2. Wheel Zoom Effect (Works when not resizing)
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const el = document.getElementById("map-container");
//     if (!el) return;

//     const handleWheel = (e) => {
//       e.preventDefault();
//       const scaleAmount = e.deltaY < 0 ? 1.1 : 0.9;
//       let newZoom = zoom * scaleAmount;

//       // الالتزام بـ minZoom المحسوب في الـ resize لمنع الفراغ الأبيض
//       newZoom = Math.max(Math.min(newZoom, 2), minZoom);

//       const rect = el.getBoundingClientRect();
//       const mouseX = e.clientX - rect.left;
//       const mouseY = e.clientY - rect.top;

//       const zoomRatio = newZoom / zoom;
//       let newX = mouseX - (mouseX - pos.x) * zoomRatio;
//       let newY = mouseY - (mouseY - pos.y) * zoomRatio;

//       // منع الخروج عن الحدود أثناء الزوم
//       const scaledW = mapWidth * newZoom;
//       const scaledH = mapHeight * newZoom;
//       const minX = window.innerWidth - scaledW;
//       const minY = window.innerHeight - scaledH;

//       // إذا كانت الماب أصغر من الشاشة (مستحيل عملياً بسبب minZoom) يتم التوسيط، غير ذلك يتم التقييد
//       newX =
//         scaledW < window.innerWidth
//           ? (window.innerWidth - scaledW) / 2
//           : Math.max(Math.min(newX, 0), minX);
//       newY =
//         scaledH < window.innerHeight
//           ? (window.innerHeight - scaledH) / 2
//           : Math.max(Math.min(newY, 0), minY);

//       setZoom(newZoom);
//       setPos({ x: newX, y: newY });
//     };

//     el.addEventListener("wheel", handleWheel, { passive: false });
//     return () => el.removeEventListener("wheel", handleWheel);
//   }, [zoom, pos, minZoom, mapWidth, mapHeight]);

//   // ------------------------------------------------------------------
//   // Villa interaction handlers
//   // ------------------------------------------------------------------

//   // const handleVillaClick = (villa) => {
//   //   if (!villa || !villa.center) return;

//   //   const fullVillaData = units.find((u) => u.code === villa.id);

//   //   setSearchParams({ unit: villa.code });
//   //   setSelectedVilla({ ...villa, ...(fullVillaData || {}) });

//   //   setIsAnimating(true);

//   //   // الزوم المطلوب عند التحديد هو 1.2 كما طلبتِ
//   //   const targetZoom = 1;

//   //   // حساب الموقع بحيث تكون الفيلا في منتصف الشاشة عرضاً، وتحت المنتصف طولاً (عشان الكارد)
//   //   const villaX = villa.center.x * targetZoom * (mapWidth / viewBoxWidth);
//   //   const villaY = villa.center.y * targetZoom * (mapHeight / viewBoxHeight);

//   //   const screenCenterX = window.innerWidth / 2;
//   //   const screenTargetY = window.innerHeight / 1.5; // الإزاحة لتحت

//   //   let newX = screenCenterX - villaX;
//   //   let newY = screenTargetY - villaY;

//   //   // قيود الحدود
//   //   const scaledW = mapWidth * targetZoom;
//   //   const scaledH = mapHeight * targetZoom;
//   //   const minX = window.innerWidth - scaledW;
//   //   const minY = window.innerHeight - scaledH;

//   //   newX = Math.max(Math.min(newX, 0), minX);
//   //   newY = Math.max(Math.min(newY, 0), minY);

//   //   // الأنميشن
//   //   const duration = 800;
//   //   const startTime = performance.now();
//   //   const startZoom = zoom;
//   //   const startX = pos.x;
//   //   const startY = pos.y;

//   //   const animate = (time) => {
//   //     const progress = Math.min((time - startTime) / duration, 1);
//   //     const ease = 1 - Math.pow(1 - progress, 3); // Smooth Out Cubic

//   //     setZoom(startZoom + (targetZoom - startZoom) * ease);
//   //     setPos({
//   //       x: startX + (newX - startX) * ease,
//   //       y: startY + (newY - startY) * ease,
//   //     });

//   //     if (progress < 1) {
//   //       requestAnimationFrame(animate);
//   //     } else {
//   //       setIsAnimating(false);
//   //     }
//   //   };
//   //   requestAnimationFrame(animate);
//   // };

//   const handleVillaMouseEnter = (villaId) => {
//     setHoveredVilla(villaId);
//   };
//   const handleVillaMouseLeave = () => {
//     setHoveredVilla(null);
//   };
//   // const handleMapClick = (e) => {
//   //   if (e.target.tagName !== "path") {
//   //     setSelectedVilla(null);
//   //     // setSearchParams({});
//   //   }
//   // };
//   const handleMapClick = (e) => {
//     // التأكد أن الضغطة ليست على مسار SVG (فيلا) وليست داخل الكارد
//     if (e.target.tagName !== "path" && !e.target.closest(".base-card-unit-")) {
//       // setSelectedVilla(null);
//       setSearchParams({}, { replace: true }); // مسح الـ URL بأمان
//       didDebugFromUrl.current = false; // اسمحي له يقرأ من الـ URL تاني لو اليوزر اختار فيلا جديدة
//     }
//   };
//   // ------------------------------------------------------------------
//   // Mobile touch hook
//   // ------------------------------------------------------------------
//   const { onTouchStart, onTouchMove, onTouchEnd, onTouchCancel } =
//     useMobileTouch({
//       mapWidth,
//       mapHeight,
//       zoom,
//       setZoom,
//       setPos,
//       setDragging,
//       setVelocity,
//       dragging,
//       lastPos,
//       setLastPos,
//       velocity,
//       minZoom: 0.5,
//       maxZoom: 2,
//     });
//   // useEffect(() => {
//   //   if (didDebugFromUrl.current) return;

//   //   const unitCode = searchParams.get("unit");
//   //   // console.log("[URL] unit param:", unitCode);

//   //   if (!unitCode) {
//   //     // console.warn("[URL] No unit in URL");
//   //     return;
//   //   }

//   //   if (!units.length) {
//   //     // console.warn("[DATA] units not loaded yet");
//   //     return;
//   //   }

//   //   const villa = units.find((u) => u.code === unitCode);

//   //   if (!villa) {
//   //     // console.error("[DATA] Villa not found in units:", unitCode);
//   //     return;
//   //   }

//   //   // ✅ الصح هنا
//   //   let center = villa.center;

//   //   if (!center) {
//   //     center = unitsSvgRef.current?.getCenterByCode(villa.code);
//   //   }

//   //   if (!center) {
//   //     // console.error("[DATA] Cannot resolve center for villa:", villa.code);
//   //     return;
//   //   }

//   //   didDebugFromUrl.current = true;

//   //   focusOnVilla({ ...villa, center });
//   // }, [searchParams, units]);

//   const focusOnVilla = (villa) => {
//     const fullVillaData = units.find((u) => u.code === villa.code);

//     setSelectedVilla({ ...villa, ...(fullVillaData || {}) });
//     setIsAnimating(true);

//     // زوم مناسب لرؤية التفاصيل والكارد
//     const targetZoom = 0.8;

//     const villaX = villa.center.x * targetZoom * (mapWidth / viewBoxWidth);
//     const villaY = villa.center.y * targetZoom * (mapHeight / viewBoxHeight);

//     const screenCenterX = window.innerWidth / 2;
//     // جعل الفيلا تظهر عند 75% من ارتفاع الشاشة (يعني نازلة لتحت)
//     const screenTargetY = window.innerHeight * 0.75;

//     let newX = screenCenterX - villaX;
//     let newY = screenTargetY - villaY;

//     const scaledW = mapWidth * targetZoom;
//     const scaledH = mapHeight * targetZoom;

//     // --- تعديل القيود (الـ Clamp) لفك القفل العلوي ---
//     const maxX = 0;
//     const maxY = 500; // السماح للماب بالنزول لأسفل بمقدار 500 بكسل
//     const minX = window.innerWidth - scaledW;
//     const minY = window.innerHeight - scaledH;

//     // تطبيق القيود الجديدة
//     newX = Math.max(Math.min(newX, maxX), minX);
//     newY = Math.max(Math.min(newY, maxY), minY);

//     const duration = 800;
//     const startTime = performance.now();
//     const startZoom = zoom;
//     const startX = pos.x;
//     const startY = pos.y;

//     const animate = (time) => {
//       const progress = Math.min((time - startTime) / duration, 1);
//       const ease = 1 - Math.pow(1 - progress, 3);

//       setZoom(startZoom + (targetZoom - startZoom) * ease);
//       setPos({
//         x: startX + (newX - startX) * ease,
//         y: startY + (newY - startY) * ease,
//       });

//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       } else {
//         setIsAnimating(false);
//       }
//     };

//     requestAnimationFrame(animate);
//   };

//   // useEffect(() => {
//   //   const unitCode = searchParams.get("unit");

//   //   // الحالة الأولى: الـ URL فاضي -> اقفل الكارد فوراً واخرج
//   //   if (!unitCode) {
//   //     setSelectedVilla(null);
//   //     return; // مهم جداً عشان الكود اللي تحت ميتنفذش
//   //   }

//   //   // الحالة الثانية: فيه كود في الـ URL
//   //   if (units.length > 0) {
//   //     // لو الفيلا اللي في الـ URL هي هي اللي معروضة، متعملش حاجة (بتمنع الـ Flickering)
//   //     if (selectedVilla?.code === unitCode) return;

//   //     const villa = units.find((u) => u.code === unitCode);
//   //     if (villa) {
//   //       const center =
//   //         villa.center || unitsSvgRef.current?.getCenterByCode(villa.code);
//   //       if (center) {
//   //         focusOnVilla({ ...villa, center });
//   //       }
//   //     }
//   //   }
//   // }, [searchParams, units, selectedVilla?.code]); // بنراقب كود الفيلا بس

//   useEffect(() => {
//     const unitCode = searchParams.get("unit");

//     // 1. لو الـ URL اتمسح خالص، اقفلي الكارد فوراً
//     if (!unitCode) {
//       setSelectedVilla(null);
//       return;
//     }

//     // 2. لو فيه كود في الـ URL
//     if (units.length > 0) {
//       // التعديل السحري: لو الكود اللي في الـ URL مختلف عن اللي في الـ State
//       // حدثي الـ State فوراً بالبيانات الجديدة قبل ما يبدأ الأنميشن
//       if (selectedVilla?.code !== unitCode) {
//         const villa = units.find((u) => u.code === unitCode);
//         if (villa) {
//           const center =
//             villa.center || unitsSvgRef.current?.getCenterByCode(villa.code);

//           if (center) {
//             // تحديث الداتا فوراً لمنع ظهور الفيلا القديمة
//             setSelectedVilla({ ...villa });
//             // بدأ الفوكس والأنميشن
//             focusOnVilla({ ...villa, center });
//           }
//         }
//       }
//     }
//   }, [searchParams, units]); // شيلنا selectedVilla.code من هنا عشان نمنع الـ Loop

//   //   // 1. هاتي filteredUnits من الـ context
//   // const { filteredUnits } = useFilterContext();

//   // // 2. راقبي عدد الوحدات المفلترة
//   // useEffect(() => {
//   //   // لو فيه نتيجة واحدة بس، والمستخدم كاتب حاجة في السيرش (عشان ميعملش فوكس والفلتر فاضي)
//   //   if (filteredUnits.length === 1 && !selectedVilla) {
//   //     const targetUnit = filteredUnits[0];

//   //     // بنحاول نجيب السنتر بتاع الوحدة من الـ SVG Ref
//   //     const center = unitsSvgRef.current?.getCenterByCode(targetUnit.code);

//   //     if (center) {
//   //       // تنفيذ الفوكس والأنميشن كأننا ضغطنا عليها بالظبط
//   //       focusOnVilla({ ...targetUnit, center });

//   //       // تحديث الـ URL عشان يظهر الكارد وتكمل تجربة الـ "كليك"
//   //       setSearchParams({ unit: targetUnit.code }, { replace: true });
//   //     }
//   //   }

//   //   // لو السيرش اتمسح أو النتائج زادت عن 1، ممكن اختياريًا نقفل السليكشن
//   //   // if (filteredUnits.length !== 1 && selectedVilla) {
//   //   //    setSelectedVilla(null);
//   //   // }

//   // }, [filteredUnits, focusOnVilla, setSearchParams, selectedVilla]);

//   useEffect(() => {
//     // بنشغل المنطق ده فقط لو المستخدم كاتب نص فعلاً في السيرش
//     if (searchText.trim() !== "" && filteredUnits.length === 1) {
//       const targetUnit = filteredUnits[0];

//       // لو الفيلا اللي ظهرت حالياً مختلفة عن اللي كانت مختارة قبل كده
//       if (selectedVilla?.code !== targetUnit.code) {
//         const center = unitsSvgRef.current?.getCenterByCode(targetUnit.code);

//         if (center) {
//           // 1. تحديث الـ URL فوراً
//           setSearchParams({ unit: targetUnit.code }, { replace: true });

//           // 2. عمل الأنميشن والفوكس
//           focusOnVilla({ ...targetUnit, center });
//         }
//       }
//     }
//   }, [filteredUnits, searchText, focusOnVilla, setSearchParams, selectedVilla]);

//   const handleVillaClick = (villa) => {
//     if (!villa || !villa.center) return;

//     setSearchParams({ unit: villa.code });
//     focusOnVilla(villa);
//   };
//   // 1. تأكدي إن الكود ده موجود جوه الكومبوننت
//   const visibleTileKeys = useMemo(() => {
//     const keys = new Set();
//     const buffer = 1;

//     const startRow = Math.max(
//       0,
//       Math.floor(-pos.y / (tileSize * zoom)) - buffer,
//     );
//     const endRow = Math.min(
//       rows,
//       Math.ceil((window.innerHeight - pos.y) / (tileSize * zoom)) + buffer,
//     );
//     const startCol = Math.max(
//       0,
//       Math.floor(-pos.x / (tileSize * zoom)) - buffer,
//     );
//     const endCol = Math.min(
//       cols,
//       Math.ceil((window.innerWidth - pos.x) / (tileSize * zoom)) + buffer,
//     );

//     for (let row = startRow; row < endRow; row++) {
//       for (let col = startCol; col < endCol; col++) {
//         keys.add(`${col}-${row}`);
//       }
//     }
//     return keys;
//   }, [pos.x, pos.y, zoom]); // الحساب هنا سريع جداً لأنه أرقام بس
//   // ------------------------------------------------------------------
//   // Render
//   // ------------------------------------------------------------------
//   return (
//     <div
//       id="map-container"
//       dir="ltr"
//       style={{
//         width: "100vw",
//         height: "100vh",
//         overflow: "hidden",
//         position: "relative",
//         cursor: dragging ? "grabbing" : "grab",
//         userSelect: "none",
//         touchAction: "none",
//       }}
//       onMouseDown={onMouseDown}
//       onMouseMove={onMouseMove}
//       onMouseUp={onMouseUp}
//       onMouseLeave={onMouseUp}
//       onTouchStart={onTouchStart}
//       onTouchMove={onTouchMove}
//       onTouchEnd={onTouchEnd}
//       onTouchCancel={onTouchCancel}
//       onClick={handleMapClick}
//     >
//       {/* <div
//         style={{
//           transform: `translate(${pos.x}px, ${pos.y}px) scale(${zoom})`,
//           transformOrigin: "top left",
//           willChange: "transform",
//           width: mapWidth,
//           height: mapHeight,
//         }}
//       >
//         {cachedVisibleTiles.map(({ tileKey, row, col }) => {
//           const img = imageCacheRef.current[tileKey];
//           if (!img) return null;
//           return (
//             <img
//               key={tileKey}
//               src={img.src}
//               alt=""
//               width={tileSize}
//               height={tileSize}
//               draggable="false"
//               style={{
//                 position: "absolute",
//                 left: col * tileSize,
//                 top: row * tileSize,
//                 // --- الإضافات الجديدة ---
//                 // imageRendering: "crisp-edges", // أو 'pixelated' لو الصور خرائط دقيقة
//                 // WebkitBackfaceVisibility: "hidden", // لمنع الرعشة أثناء الزوم
//                 // transform: "translateZ(0)", // إجبار المتصفح على استخدام كارت الشاشة GPU
//               }}
//             />
//           );
//         })}
//       </div> */}
//       {/* /* --- استبدلي جزء عرض الصور في الـ return بهذا الكود --- */}
//       <div
//         style={{
//           transform: `translate3d(${pos.x}px, ${pos.y}px, 0) scale(${zoom})`, // استخدام translate3d أفضل للأداء
//           transformOrigin: "top left",
//           willChange: "transform",
//           width: mapWidth,
//           height: mapHeight,
//         }}
//       >
//         {Object.entries(tilesMap).map(([tileKey, imagePath]) => {
//           const [col, row] = tileKey.split("-").map(Number);
//           const isVisible = visibleTileKeys.has(tileKey);

//           // لو التايل دي مش ظاهرة حالياً، ومش موجودة في الـ Ref (يعني ملمسناهاش قبل كده)، متترسمش أصلاً
//           if (!isVisible && !loadedTilesRef.current.has(tileKey)) return null;

//           return (
//             <img
//               key={tileKey}
//               src={`https://api.gravity-proptech.com/public/storage/${imagePath}`}
//               alt=""
//               width={tileSize}
//               height={tileSize}
//               draggable="false"
//               onLoad={() => loadedTilesRef.current.add(tileKey)} // بنسجل إنها اتحملت عشان متختفيش
//               style={{
//                 position: "absolute",
//                 left: col * tileSize,
//                 top: row * tileSize,
//                 display: isVisible ? "block" : "none", // السر هنا: بنخفيها بس مش بنشيلها من الـ DOM
//                 WebkitBackfaceVisibility: "hidden",
//                 transform: "translateZ(0)",
//               }}
//             />
//           );
//         })}
//       </div>
//       {/* <div
//   style={{
//     transform: `translate(${pos.x}px, ${pos.y}px) scale(${zoom})`,
//     transformOrigin: "top left",
//     willChange: "transform",
//     width: mapWidth,
//     height: mapHeight,
//   }}
// >
//   {Object.entries(tilesMap).map(([tileKey, imagePath]) => {
//     const [col, row] = tileKey.split("-").map(Number);
//     return (
//       <img
//         key={tileKey}
//         src={`https://api.gravity-proptech.com/public/storage/${imagePath}`}
//         alt=""
//         width={tileSize}
//         height={tileSize}
//         draggable="false"
//         loading="lazy"
//         style={{
//           position: "absolute",
//           left: col * tileSize,
//           top: row * tileSize,
//           WebkitBackfaceVisibility: "hidden",
//           transform: "translateZ(0)",
//           imageRendering: "pixelated",
//           display: "block",
//         }}
//       />
//     );
//   })}
// </div> */}
//       {/* Overlay SVGs */}
//       <div
//         style={{
//           position: "absolute",
//           left: pos.x,
//           top: pos.y,
//           width: mapWidth,
//           height: mapHeight,
//           transform: `scale(${zoom})`,
//           transformOrigin: "top left",
//           zIndex: 99,
//         }}
//       >
//         {!isOverlayHidden && (
//           <UnitsSvg
//             ref={unitsSvgRef}
//             mapWidth={mapWidth}
//             mapHeight={mapHeight}
//             clickableLayer={clickableLayerSvgString}
//             units={units}
//             hoveredVilla={hoveredVilla}
//             selectedVilla={selectedVilla}
//             onMouseEnter={handleVillaMouseEnter}
//             onMouseLeave={handleVillaMouseLeave}
//             onVillaClick={handleVillaClick}
//             activeTab={activeTab}
//             cancelledTypes={filterSelection?.cancelledTypes || []}
//             cancelledAvailability={filterSelection?.cancelledAvailability || []}
//             progressCategories={filterSelection?.progressCategories || []}
//             filters={filters}
//             bookingDate={filterSelection?.booking_date}
//           />
//         )}
//       </div>

//       {/* Selected villa card */}
//       {selectedVilla && !isAnimating && (
//         <div
//           style={{
//             position: "fixed",
//             left:
//               pos.x + selectedVilla.center.x * zoom * (mapWidth / viewBoxWidth),
//             top:
//               pos.y +
//               selectedVilla.center.y * zoom * (mapHeight / viewBoxHeight),
//             zIndex: 999,
//             transform: "translate(-50%, -110%)",
//           }}
//         >
//           <VillaCard
//             lang={lang}
//             page="master-plan"
//             width="340px"
//             villa={selectedVilla}
//             onShowProgress={setProgressVilla}
//             onOpenModal={() => {
//               setSpinVilla(selectedVilla);
//             }}
//           />
//         </div>
//       )}
//     </div>
//   );
// }

// function MasterPlane({
//   lang,
//   filterSelection,
//   isOverlayHidden,
//   filters,
//   setProgressVilla,
//   setSpinVilla,
//   projectSlug,
// }) {
//   return (
//     <MasterPlaneInner
//       projectSlug={projectSlug}
//       filterSelection={filterSelection}
//       isOverlayHidden={isOverlayHidden}
//       filters={filters}
//       lang={lang}
//       setProgressVilla={setProgressVilla}
//       setSpinVilla={setSpinVilla}
//     />
//   );
// }

// export default MasterPlane;
// كانفس
// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useZone } from "../../context/ZoneContext";
// import VillaCard from "../villacard/VillaCard";
// import useMobileTouch from "./mopile/useMopileTouch";
// import { useRangeFilter } from "../../context/rangeFilterContext";
// import UnitsSvg from "./svg/unitSvg";
// import { useTabsFilter } from "../../context/TabsFilterContext";
// import { useSearchParams } from "react-router-dom";

// import { useFilterContext } from "../../context/FilterContext";

// function MasterPlaneInner({
//   setProgressVilla,
//   setSpinVilla,
//   filterSelection,
//   isOverlayHidden,
//   lang,
// }) {
//   const { filteredUnits, searchText } = useFilterContext();
//   const { filters } = useRangeFilter();
//   const { units = [], project: projectData } = useZone();
//   const clickableLayerSvgString = projectData?.clickable_layer || null;
//   const { activeTab } = useTabsFilter();
//   const [searchParams, setSearchParams] = useSearchParams();

//   const unitsSvgRef = useRef(null);
//   const canvasRef = useRef(null);
//   const imagesCacheRef = useRef({}); // لتخزين الصور المحملة ومنع وميض الشاشة

//   // ------------------------------------------------------------------
//   // Tiles Map (background images)
//   // ------------------------------------------------------------------
//   const tilesMap = useMemo(() => {
//     if (!projectData?.building_images) return {};

//     const map = {};
//     projectData.building_images.forEach((item) => {
//       const match = item.image.match(/tile_(\d+)_(\d+)\.jpg$/);
//       if (match) {
//         const col = match[1];
//         const row = match[2];
//         map[`${col}-${row}`] = item.image;
//       }
//     });
//     return map;
//   }, [projectData]);

//   // ------------------------------------------------------------------
//   // Constants
//   // ------------------------------------------------------------------
//   const rows = 32;
//   const cols = 32;
//   const tileSize = 512;

//   const mapWidth = cols * tileSize;
//   const mapHeight = rows * tileSize;
//   const viewBoxWidth = 1638.4;
//   const viewBoxHeight = 1638.4;

//   // ------------------------------------------------------------------
//   // State
//   // ------------------------------------------------------------------
//   const [zoom, setZoom] = useState(1);
//   const [dragging, setDragging] = useState(false);
//   const [selectedVilla, setSelectedVilla] = useState(null);
//   const [hoveredVilla, setHoveredVilla] = useState(null);
//   const [minZoom, setMinZoom] = useState(1);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [velocity, setVelocity] = useState({ x: 0, y: 0 });
//   const [lastPos, setLastPos] = useState({ x: 0, y: 0 });
//   const didDebugFromUrl = useRef(false);

//   const initialZoom = Math.max(
//     window.innerWidth / mapWidth,
//     window.innerHeight / mapHeight,
//   );

//   const [pos, setPos] = useState({
//     x: (window.innerWidth - mapWidth * initialZoom) / 2,
//     y: (window.innerHeight - mapHeight * initialZoom) / 2,
//   });

//   const loadedTilesRef = useRef(new Set());

//   // ------------------------------------------------------------------
//   // Canvas Drawing Logic
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;
//     const ctx = canvas.getContext("2d");

//     // تحديد الـ Tiles الظاهرة حالياً فقط للرسم
//     const buffer = 1;
//     const startRow = Math.max(
//       0,
//       Math.floor(-pos.y / (tileSize * zoom)) - buffer,
//     );
//     const endRow = Math.min(
//       rows,
//       Math.ceil((window.innerHeight - pos.y) / (tileSize * zoom)) + buffer,
//     );
//     const startCol = Math.max(
//       0,
//       Math.floor(-pos.x / (tileSize * zoom)) - buffer,
//     );
//     const endCol = Math.min(
//       cols,
//       Math.ceil((window.innerWidth - pos.x) / (tileSize * zoom)) + buffer,
//     );

//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     for (let row = startRow; row < endRow; row++) {
//       for (let col = startCol; col < endCol; col++) {
//         const tileKey = `${col}-${row}`;
//         const imagePath = tilesMap[tileKey];
//         if (!imagePath) continue;

//         const fullUrl = `https://api.gravity-proptech.com/public/storage/${imagePath}`;

//         if (!imagesCacheRef.current[tileKey]) {
//           const img = new Image();
//           img.src = fullUrl;
//           img.onload = () => {
//             imagesCacheRef.current[tileKey] = img;
//             // إعادة الرسم بمجرد تحميل الصورة
//             renderCanvas();
//           };
//         } else {
//           const img = imagesCacheRef.current[tileKey];
//           // رسم الصورة مع مراعاة الموقع والزوم
//           ctx.drawImage(
//             img,
//             col * tileSize * zoom + pos.x,
//             row * tileSize * zoom + pos.y,
//             tileSize * zoom,
//             tileSize * zoom,
//           );
//         }
//       }
//     }

//     function renderCanvas() {
//       // هذه الوظيفة تستدعى عند تحميل صور جديدة لتحديث الكانفس
//       if (!canvas) return;
//       const currentCtx = canvas.getContext("2d");
//       currentCtx.clearRect(0, 0, canvas.width, canvas.height);
//       for (let r = startRow; r < endRow; r++) {
//         for (let c = startCol; c < endCol; c++) {
//           const key = `${c}-${r}`;
//           const cachedImg = imagesCacheRef.current[key];
//           if (cachedImg) {
//             currentCtx.drawImage(
//               cachedImg,
//               c * tileSize * zoom + pos.x,
//               r * tileSize * zoom + pos.y,
//               tileSize * zoom,
//               tileSize * zoom,
//             );
//           }
//         }
//       }
//     }
//   }, [pos, zoom, tilesMap]);

//   // ------------------------------------------------------------------
//   // Initial setup & resize handling
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const newMinZoom = Math.max(
//       window.innerWidth / mapWidth,
//       window.innerHeight / mapHeight,
//     );
//     setMinZoom(newMinZoom);
//     setZoom(newMinZoom);
//     setPos({
//       x: (window.innerWidth - mapWidth * newMinZoom) / 2,
//       y: (window.innerHeight - mapHeight * newMinZoom) / 2,
//     });
//   }, []);

//   // ------------------------------------------------------------------
//   // Mouse drag handlers
//   // ------------------------------------------------------------------
//   const onMouseDown = (e) => {
//     setDragging(true);
//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: 0, y: 0 });
//   };

//   const onMouseMove = (e) => {
//     if (!dragging) return;
//     const dx = e.clientX - lastPos.x;
//     const dy = e.clientY - lastPos.y;
//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: dx / 16, y: dy / 16 });
//     setPos((prev) => {
//       const scaledWidth = mapWidth * zoom;
//       const scaledHeight = mapHeight * zoom;
//       const maxX = 0;
//       const maxY = 0;
//       const minX =
//         scaledWidth < window.innerWidth
//           ? (window.innerWidth - scaledWidth) / 2
//           : -scaledWidth + window.innerWidth;
//       const minY =
//         scaledHeight < window.innerHeight
//           ? (window.innerHeight - scaledHeight) / 2
//           : -scaledHeight + window.innerHeight;
//       let newX = prev.x + dx;
//       let newY = prev.y + dy;
//       return {
//         x: Math.max(Math.min(newX, maxX), minX),
//         y: Math.max(Math.min(newY, maxY), minY),
//       };
//     });
//   };

//   const onMouseUp = () => {
//     if (!dragging) return;
//     setDragging(false);
//     let vx = velocity.x * 0.5;
//     let vy = velocity.y * 0.5;
//     const decay = 0.75;
//     const speedFactor = 15;
//     const animate = () => {
//       setPos((prev) => {
//         const scaledWidth = mapWidth * zoom;
//         const scaledHeight = mapHeight * zoom;
//         const maxX = 0;
//         const maxY = 0;
//         const minX =
//           scaledWidth < window.innerWidth
//             ? (window.innerWidth - scaledWidth) / 2
//             : -scaledWidth + window.innerWidth;
//         const minY =
//           scaledHeight < window.innerHeight
//             ? (window.innerHeight - scaledHeight) / 2
//             : -scaledHeight + window.innerHeight;
//         let newX = prev.x + vx * speedFactor;
//         let newY = prev.y + vy * speedFactor;
//         if (newX >= maxX || newX <= minX) vx = 0;
//         if (newY >= maxY || newY <= minY) vy = 0;
//         newX = Math.max(Math.min(newX, maxX), minX);
//         newY = Math.max(Math.min(newY, maxY), minY);
//         return { x: newX, y: newY };
//       });
//       vx *= decay;
//       vy *= decay;
//       if (Math.abs(vx) > 0.01 || Math.abs(vy) > 0.01) {
//         requestAnimationFrame(animate);
//       }
//     };
//     requestAnimationFrame(animate);
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       const vw = window.innerWidth;
//       const vh = window.innerHeight;
//       const newMinZoom = Math.max(vw / mapWidth, vh / mapHeight);
//       setMinZoom(newMinZoom);
//       if (selectedVilla) {
//         setPos(() => {
//           const villaX =
//             selectedVilla.center.x * zoom * (mapWidth / viewBoxWidth);
//           const villaY =
//             selectedVilla.center.y * zoom * (mapHeight / viewBoxHeight);
//           let newX = vw / 2 - villaX;
//           let newY = vh / 1.5 - villaY;
//           const scaledW = mapWidth * zoom;
//           const scaledH = mapHeight * zoom;
//           const minX = vw - scaledW;
//           const minY = vh - scaledH;
//           newX =
//             scaledW < vw
//               ? (vw - scaledW) / 2
//               : Math.max(Math.min(newX, 0), minX);
//           newY =
//             scaledH < vh
//               ? (vh - scaledH) / 2
//               : Math.max(Math.min(newY, 0), minY);
//           return { x: newX, y: newY };
//         });
//       } else {
//         setZoom(newMinZoom);
//         setPos({
//           x: (vw - mapWidth * newMinZoom) / 2,
//           y: (vh - mapHeight * newMinZoom) / 2,
//         });
//       }
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [selectedVilla, zoom, mapWidth, mapHeight]);

//   useEffect(() => {
//     const el = document.getElementById("map-container");
//     if (!el) return;
//     const handleWheel = (e) => {
//       e.preventDefault();
//       const scaleAmount = e.deltaY < 0 ? 1.1 : 0.9;
//       let newZoom = zoom * scaleAmount;
//       newZoom = Math.max(Math.min(newZoom, 2), minZoom);
//       const rect = el.getBoundingClientRect();
//       const mouseX = e.clientX - rect.left;
//       const mouseY = e.clientY - rect.top;
//       const zoomRatio = newZoom / zoom;
//       let newX = mouseX - (mouseX - pos.x) * zoomRatio;
//       let newY = mouseY - (mouseY - pos.y) * zoomRatio;
//       const scaledW = mapWidth * newZoom;
//       const scaledH = mapHeight * newZoom;
//       const minX = window.innerWidth - scaledW;
//       const minY = window.innerHeight - scaledH;
//       newX =
//         scaledW < window.innerWidth
//           ? (window.innerWidth - scaledW) / 2
//           : Math.max(Math.min(newX, 0), minX);
//       newY =
//         scaledH < window.innerHeight
//           ? (window.innerHeight - scaledH) / 2
//           : Math.max(Math.min(newY, 0), minY);
//       setZoom(newZoom);
//       setPos({ x: newX, y: newY });
//     };
//     el.addEventListener("wheel", handleWheel, { passive: false });
//     return () => el.removeEventListener("wheel", handleWheel);
//   }, [zoom, pos, minZoom, mapWidth, mapHeight]);

//   const handleVillaMouseEnter = (villaId) => setHoveredVilla(villaId);
//   const handleVillaMouseLeave = () => setHoveredVilla(null);
//   const handleMapClick = (e) => {
//     if (e.target.tagName !== "path" && !e.target.closest(".base-card-unit-")) {
//       setSearchParams({}, { replace: true });
//       didDebugFromUrl.current = false;
//     }
//   };

//   const { onTouchStart, onTouchMove, onTouchEnd, onTouchCancel } =
//     useMobileTouch({
//       mapWidth,
//       mapHeight,
//       zoom,
//       setZoom,
//       setPos,
//       setDragging,
//       setVelocity,
//       dragging,
//       lastPos,
//       setLastPos,
//       velocity,
//       minZoom: 0.5,
//       maxZoom: 2,
//     });

//   const focusOnVilla = (villa) => {
//     const fullVillaData = units.find((u) => u.code === villa.code);
//     setSelectedVilla({ ...villa, ...(fullVillaData || {}) });
//     setIsAnimating(true);
//     const targetZoom = 0.8;
//     const villaX = villa.center.x * targetZoom * (mapWidth / viewBoxWidth);
//     const villaY = villa.center.y * targetZoom * (mapHeight / viewBoxHeight);
//     const screenCenterX = window.innerWidth / 2;
//     const screenTargetY = window.innerHeight * 0.75;
//     let newX = screenCenterX - villaX;
//     let newY = screenTargetY - villaY;
//     const scaledW = mapWidth * targetZoom;
//     const scaledH = mapHeight * targetZoom;
//     const maxX = 0;
//     const maxY = 500;
//     const minX = window.innerWidth - scaledW;
//     const minY = window.innerHeight - scaledH;
//     newX = Math.max(Math.min(newX, maxX), minX);
//     newY = Math.max(Math.min(newY, maxY), minY);
//     const duration = 800;
//     const startTime = performance.now();
//     const startZoom = zoom;
//     const startX = pos.x;
//     const startY = pos.y;
//     const animate = (time) => {
//       const progress = Math.min((time - startTime) / duration, 1);
//       const ease = 1 - Math.pow(1 - progress, 3);
//       setZoom(startZoom + (targetZoom - startZoom) * ease);
//       setPos({
//         x: startX + (newX - startX) * ease,
//         y: startY + (newY - startY) * ease,
//       });
//       if (progress < 1) requestAnimationFrame(animate);
//       else setIsAnimating(false);
//     };
//     requestAnimationFrame(animate);
//   };

//   useEffect(() => {
//     const unitCode = searchParams.get("unit");
//     if (!unitCode) {
//       setSelectedVilla(null);
//       return;
//     }
//     if (units.length > 0) {
//       if (selectedVilla?.code !== unitCode) {
//         const villa = units.find((u) => u.code === unitCode);
//         if (villa) {
//           const center =
//             villa.center || unitsSvgRef.current?.getCenterByCode(villa.code);
//           if (center) {
//             setSelectedVilla({ ...villa });
//             focusOnVilla({ ...villa, center });
//           }
//         }
//       }
//     }
//   }, [searchParams, units]);

//   useEffect(() => {
//     if (searchText.trim() !== "" && filteredUnits.length === 1) {
//       const targetUnit = filteredUnits[0];
//       if (selectedVilla?.code !== targetUnit.code) {
//         const center = unitsSvgRef.current?.getCenterByCode(targetUnit.code);
//         if (center) {
//           setSearchParams({ unit: targetUnit.code }, { replace: true });
//           focusOnVilla({ ...targetUnit, center });
//         }
//       }
//     }
//   }, [filteredUnits, searchText, focusOnVilla, setSearchParams, selectedVilla]);

//   const handleVillaClick = (villa) => {
//     if (!villa || !villa.center) return;
//     setSearchParams({ unit: villa.code });
//     focusOnVilla(villa);
//   };

//   return (
//     <div
//       id="map-container"
//       dir="ltr"
//       style={{
//         width: "100vw",
//         height: "100vh",
//         overflow: "hidden",
//         position: "relative",
//         cursor: dragging ? "grabbing" : "grab",
//         userSelect: "none",
//         touchAction: "none",
//         // background: "#000"
//       }}
//       onMouseDown={onMouseDown}
//       onMouseMove={onMouseMove}
//       onMouseUp={onMouseUp}
//       onMouseLeave={onMouseUp}
//       onTouchStart={onTouchStart}
//       onTouchMove={onTouchMove}
//       onTouchEnd={onTouchEnd}
//       onTouchCancel={onTouchCancel}
//       onClick={handleMapClick}
//     >
//       {/* Canvas for Background Tiles */}
//       <canvas
//         ref={canvasRef}
//         width={window.innerWidth}
//         height={window.innerHeight}
//         style={{
//           position: "absolute",
//           top: 0,
//           left: 0,
//           display: "block",
//           pointerEvents: "none", // التأكد أن الكانفس لا يعيق الكليكات
//         }}
//       />

//       {/* Overlay SVGs - تبقى كما هي للتفاعل */}
//       <div
//         style={{
//           position: "absolute",
//           left: pos.x,
//           top: pos.y,
//           width: mapWidth,
//           height: mapHeight,
//           transform: `scale(${zoom})`,
//           transformOrigin: "top left",
//           zIndex: 99,
//           pointerEvents: "none", // سيتم تمرير الأحداث للداخل (SVG)
//         }}
//       >
//         {!isOverlayHidden && (
//           <div style={{ pointerEvents: "auto" }}>
//             <UnitsSvg
//               ref={unitsSvgRef}
//               mapWidth={mapWidth}
//               mapHeight={mapHeight}
//               clickableLayer={clickableLayerSvgString}
//               units={units}
//               hoveredVilla={hoveredVilla}
//               selectedVilla={selectedVilla}
//               onMouseEnter={handleVillaMouseEnter}
//               onMouseLeave={handleVillaMouseLeave}
//               onVillaClick={handleVillaClick}
//               activeTab={activeTab}
//               cancelledTypes={filterSelection?.cancelledTypes || []}
//               cancelledAvailability={
//                 filterSelection?.cancelledAvailability || []
//               }
//               progressCategories={filterSelection?.progressCategories || []}
//               filters={filters}
//               bookingDate={filterSelection?.booking_date}
//             />
//           </div>
//         )}
//       </div>

//       {/* Selected villa card */}
//       {selectedVilla && !isAnimating && (
//         <div
//           style={{
//             position: "fixed",
//             left:
//               pos.x + selectedVilla.center.x * zoom * (mapWidth / viewBoxWidth),
//             top:
//               pos.y +
//               selectedVilla.center.y * zoom * (mapHeight / viewBoxHeight),
//             zIndex: 999,
//             transform: "translate(-50%, -110%)",
//           }}
//         >
//           <VillaCard
//             lang={lang}
//             page="master-plan"
//             width="340px"
//             villa={selectedVilla}
//             onShowProgress={setProgressVilla}
//             onOpenModal={() => setSpinVilla(selectedVilla)}
//           />
//         </div>
//       )}
//     </div>
//   );
// }

// function MasterPlane({
//   lang,
//   filterSelection,
//   isOverlayHidden,
//   filters,
//   setProgressVilla,
//   setSpinVilla,
//   projectSlug,
// }) {
//   return (
//     <MasterPlaneInner
//       projectSlug={projectSlug}
//       filterSelection={filterSelection}
//       isOverlayHidden={isOverlayHidden}
//       filters={filters}
//       lang={lang}
//       setProgressVilla={setProgressVilla}
//       setSpinVilla={setSpinVilla}
//     />
//   );
// }

// export default MasterPlane;








// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useZone } from "../../context/ZoneContext";
// import VillaCard from "../villacard/VillaCard";
// import useMobileTouch from "./mopile/useMopileTouch";
// import { useRangeFilter } from "../../context/rangeFilterContext";
// import UnitsSvg from "./svg/unitSvg";
// import { useTabsFilter } from "../../context/TabsFilterContext";
// import { useSearchParams } from "react-router-dom";
// function MasterPlaneInner({
//   setProgressVilla,
//   setSpinVilla,
//   filterSelection,
//   isOverlayHidden,
//   lang,
// }) {
//   const { filters } = useRangeFilter();
//   const { units = [], project: projectData } = useZone();
//   const clickableLayerSvgString = projectData?.clickable_layer || null;
//   const { activeTab } = useTabsFilter();
//   const [searchParams, setSearchParams] = useSearchParams();

//   const unitsSvgRef = useRef(null);

//   // ------------------------------------------------------------------
//   // Tiles Map (background images)
//   // ------------------------------------------------------------------
//   const tilesMap = useMemo(() => {
//     if (!projectData?.building_images) return {};

//     const map = {};
//     projectData.building_images.forEach((item) => {
//       const match = item.image.match(/tile_(\d+)_(\d+)\.jpg$/);
//       if (match) {
//         const col = match[1];
//         const row = match[2];
//         map[`${col}-${row}`] = item.image;
//       }
//     });
//     return map;
//   }, [projectData]);

//   // ------------------------------------------------------------------
//   // Constants
//   // ------------------------------------------------------------------
//   const rows = 32;
//   const cols = 32;
//   const tileSize = 512;

//   const mapWidth = cols * tileSize;
//   const mapHeight = rows * tileSize;
//   const viewBoxWidth = 1638.4;
//   const viewBoxHeight = 1638.4;

//   // ------------------------------------------------------------------
//   // State
//   // ------------------------------------------------------------------
//   const [zoom, setZoom] = useState(1);
//   const [dragging, setDragging] = useState(false);
//   const [selectedVilla, setSelectedVilla] = useState(null);
//   const [hoveredVilla, setHoveredVilla] = useState(null);
//   const [minZoom, setMinZoom] = useState(1);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [velocity, setVelocity] = useState({ x: 0, y: 0 });
//   const [lastPos, setLastPos] = useState({ x: 0, y: 0 });
//   const [loadedTiles, setLoadedTiles] = useState(new Set());
//   const didDebugFromUrl = useRef(false);

//   const initialZoom = Math.max(
//     window.innerWidth / mapWidth,
//     window.innerHeight / mapHeight,
//   );

//   const [pos, setPos] = useState({
//     x: (window.innerWidth - mapWidth * initialZoom) / 2,
//     y: (window.innerHeight - mapHeight * initialZoom) / 2,
//   });
//   // إنشاء Ref لتخزين tiles محمّلة مسبقًا
//   const loadedTilesRef = useRef(new Set());

//   // نحسب الـtiles الظاهرة + caching
//   const cachedVisibleTiles = useMemo(() => {
//     const tiles = [];
//     const buffer = 1; // tiles إضافية حول الشاشة

//     const startRow = Math.max(
//       0,
//       Math.floor(-pos.y / (tileSize * zoom)) - buffer,
//     );
//     const endRow = Math.min(
//       rows,
//       Math.ceil((window.innerHeight - pos.y) / (tileSize * zoom)) + buffer,
//     );
//     const startCol = Math.max(
//       0,
//       Math.floor(-pos.x / (tileSize * zoom)) - buffer,
//     );
//     const endCol = Math.min(
//       cols,
//       Math.ceil((window.innerWidth - pos.x) / (tileSize * zoom)) + buffer,
//     );

//     for (let row = startRow; row < endRow; row++) {
//       for (let col = startCol; col < endCol; col++) {
//         const tileKey = `${col}-${row}`;
//         const imagePath = tilesMap[tileKey];

//         if (!imagePath) continue;

//         // لو Tile جديد، أضفها للـcache
//         if (!loadedTilesRef.current.has(tileKey)) {
//           loadedTilesRef.current.add(tileKey);
//         }

//         tiles.push({ tileKey, row, col, imagePath });
//       }
//     }

//     return tiles;
//   }, [pos.x, pos.y, zoom, tilesMap]);
//   // Ref لتخزين الصور الفعلية
//   const imageCacheRef = useRef({});

//   // Preload الصور قبل render
//   useEffect(() => {
//     cachedVisibleTiles.forEach(({ tileKey, imagePath }) => {
//       if (!imageCacheRef.current[tileKey]) {
//         const img = new Image();
//         img.src = `https://api.gravity-proptech.com/public/storage/${imagePath}`;
//         imageCacheRef.current[tileKey] = img;
//       }
//     });
//   }, [cachedVisibleTiles, lang]);
//   // ------------------------------------------------------------------
//   // Initial setup & resize handling
//   // ------------------------------------------------------------------
//   const calculateInitialView = () => {
//     const currentWidth = window.innerWidth;
//     const currentHeight = window.innerHeight;
//     const newMinZoom = Math.max(
//       currentWidth / mapWidth,
//       currentHeight / mapHeight,
//     );

//     setMinZoom(newMinZoom);

//     setZoom((prevZoom) => {
//       const targetZoom = Math.max(prevZoom, newMinZoom);

//       setPos((prevPos) => {
//         let newX, newY;
//         const scaledWidth = mapWidth * targetZoom;
//         const scaledHeight = mapHeight * targetZoom;

//         if (selectedVilla) {
//           const villaScreenX =
//             selectedVilla.center.x * targetZoom * (mapWidth / viewBoxWidth);
//           const villaScreenY =
//             selectedVilla.center.y * targetZoom * (mapHeight / viewBoxHeight);

//           const centerX = currentWidth / 2;
//           const centerY = currentHeight / 1.1;
//           // const centerX = currentWidth / 2;
//           // const centerY = currentHeight / 1.5;

//           newX = centerX - villaScreenX;
//           newY = centerY - villaScreenY;
//         } else {
//           const centerMapX = (currentWidth / 2 - prevPos.x) / prevZoom;
//           const centerMapY = (currentHeight / 2 - prevPos.y) / prevZoom;

//           newX = currentWidth / 2 - centerMapX * targetZoom;
//           newY = currentHeight / 2 - centerMapY * targetZoom;
//         }

//         // Clamp
//         const maxX = 0;
//         const maxY = 0;
//         const minX =
//           scaledWidth < currentWidth
//             ? (currentWidth - scaledWidth) / 2
//             : -scaledWidth + currentWidth;
//         const minY =
//           scaledHeight < currentHeight
//             ? (currentHeight - scaledHeight) / 2
//             : -scaledHeight + currentHeight;

//         newX = Math.max(Math.min(newX, maxX), minX);
//         newY = Math.max(Math.min(newY, maxY), minY);

//         return { x: newX, y: newY };
//       });

//       return targetZoom;
//     });
//   };

//   useEffect(() => {
//     const newMinZoom = Math.max(
//       window.innerWidth / mapWidth,
//       window.innerHeight / mapHeight,
//     );

//     setMinZoom(newMinZoom);
//     setZoom(newMinZoom);
//     setPos({
//       x: (window.innerWidth - mapWidth * newMinZoom) / 2,
//       y: (window.innerHeight - mapHeight * newMinZoom) / 2,
//     });
//   }, []);

//   // ------------------------------------------------------------------
//   // Mouse drag handlers
//   // ------------------------------------------------------------------
//   const onMouseDown = (e) => {
//     setDragging(true);
//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: 0, y: 0 });
//   };

//   const onMouseMove = (e) => {
//     if (!dragging) return;

//     const dx = e.clientX - lastPos.x;
//     const dy = e.clientY - lastPos.y;

//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: dx / 16, y: dy / 16 });

//     setPos((prev) => {
//       const scaledWidth = mapWidth * zoom;
//       const scaledHeight = mapHeight * zoom;
//       const maxX = 0;
//       const maxY = 0;
//       const minX =
//         scaledWidth < window.innerWidth
//           ? (window.innerWidth - scaledWidth) / 2
//           : -scaledWidth + window.innerWidth;
//       const minY =
//         scaledHeight < window.innerHeight
//           ? (window.innerHeight - scaledHeight) / 2
//           : -scaledHeight + window.innerHeight;

//       let newX = prev.x + dx;
//       let newY = prev.y + dy;

//       return {
//         x: Math.max(Math.min(newX, maxX), minX),
//         y: Math.max(Math.min(newY, maxY), minY),
//       };
//     });
//   };

//   const onMouseUp = () => {
//     if (!dragging) return;
//     setDragging(false);

//     let vx = velocity.x * 0.5;
//     let vy = velocity.y * 0.5;
//     const decay = 0.75;
//     const speedFactor = 15;

//     const animate = () => {
//       setPos((prev) => {
//         const scaledWidth = mapWidth * zoom;
//         const scaledHeight = mapHeight * zoom;
//         const maxX = 0;
//         const maxY = 0;
//         const minX =
//           scaledWidth < window.innerWidth
//             ? (window.innerWidth - scaledWidth) / 2
//             : -scaledWidth + window.innerWidth;
//         const minY =
//           scaledHeight < window.innerHeight
//             ? (window.innerHeight - scaledHeight) / 2
//             : -scaledHeight + window.innerHeight;

//         let newX = prev.x + vx * speedFactor;
//         let newY = prev.y + vy * speedFactor;

//         if (newX >= maxX || newX <= minX) vx = 0;
//         if (newY >= maxY || newY <= minY) vy = 0;

//         newX = Math.max(Math.min(newX, maxX), minX);
//         newY = Math.max(Math.min(newY, maxY), minY);

//         return { x: newX, y: newY };
//       });

//       vx *= decay;
//       vy *= decay;

//       if (Math.abs(vx) > 0.01 || Math.abs(vy) > 0.01) {
//         requestAnimationFrame(animate);
//       }
//     };

//     requestAnimationFrame(animate);
//   };

//   // ------------------------------------------------------------------
//   // 1. Resize Effect (النسخة النهائية اللي بتحل مشكلة الـ Reset)
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const handleResize = () => {
//       const vw = window.innerWidth;
//       const vh = window.innerHeight;

//       // حساب الحد الأدنى الجديد دايماً
//       const newMinZoom = Math.max(vw / mapWidth, vh / mapHeight);
//       setMinZoom(newMinZoom);

//       if (selectedVilla) {
//         // حالة (أ): فيه فيلا -> "ثبت الزوم" وحرك الماب بس عشان الفيلا تفضل في مكانها
//         setPos(() => {
//           const villaX =
//             selectedVilla.center.x * zoom * (mapWidth / viewBoxWidth);
//           const villaY =
//             selectedVilla.center.y * zoom * (mapHeight / viewBoxHeight);

//           let newX = vw / 2 - villaX;
//           let newY = vh / 1.5 - villaY;

//           const scaledW = mapWidth * zoom;
//           const scaledH = mapHeight * zoom;
//           const minX = vw - scaledW;
//           const minY = vh - scaledH;

//           newX =
//             scaledW < vw
//               ? (vw - scaledW) / 2
//               : Math.max(Math.min(newX, 0), minX);
//           newY =
//             scaledH < vh
//               ? (vh - scaledH) / 2
//               : Math.max(Math.min(newY, 0), minY);

//           return { x: newX, y: newY };
//         });
//       } else {
//         // حالة (ب): مفيش فيلا -> "ارجع للأصل" (Reset)
//         // ده السطر اللي هيخلي الزوم يرجع يملأ الشاشة أول ما تغيري حجمها ومفيش فيلا
//         setZoom(newMinZoom);

//         setPos({
//           x: (vw - mapWidth * newMinZoom) / 2,
//           y: (vh - mapHeight * newMinZoom) / 2,
//         });
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [selectedVilla, zoom, mapWidth, mapHeight]);
//   // ------------------------------------------------------------------
//   // 2. Wheel Zoom Effect (Works when not resizing)
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const el = document.getElementById("map-container");
//     if (!el) return;

//     const handleWheel = (e) => {
//       e.preventDefault();
//       const scaleAmount = e.deltaY < 0 ? 1.1 : 0.9;
//       let newZoom = zoom * scaleAmount;

//       // الالتزام بـ minZoom المحسوب في الـ resize لمنع الفراغ الأبيض
//       newZoom = Math.max(Math.min(newZoom, 2), minZoom);

//       const rect = el.getBoundingClientRect();
//       const mouseX = e.clientX - rect.left;
//       const mouseY = e.clientY - rect.top;

//       const zoomRatio = newZoom / zoom;
//       let newX = mouseX - (mouseX - pos.x) * zoomRatio;
//       let newY = mouseY - (mouseY - pos.y) * zoomRatio;

//       // منع الخروج عن الحدود أثناء الزوم
//       const scaledW = mapWidth * newZoom;
//       const scaledH = mapHeight * newZoom;
//       const minX = window.innerWidth - scaledW;
//       const minY = window.innerHeight - scaledH;

//       // إذا كانت الماب أصغر من الشاشة (مستحيل عملياً بسبب minZoom) يتم التوسيط، غير ذلك يتم التقييد
//       newX =
//         scaledW < window.innerWidth
//           ? (window.innerWidth - scaledW) / 2
//           : Math.max(Math.min(newX, 0), minX);
//       newY =
//         scaledH < window.innerHeight
//           ? (window.innerHeight - scaledH) / 2
//           : Math.max(Math.min(newY, 0), minY);

//       setZoom(newZoom);
//       setPos({ x: newX, y: newY });
//     };

//     el.addEventListener("wheel", handleWheel, { passive: false });
//     return () => el.removeEventListener("wheel", handleWheel);
//   }, [zoom, pos, minZoom, mapWidth, mapHeight]);

//   // ------------------------------------------------------------------
//   // Villa interaction handlers
//   // ------------------------------------------------------------------

//   // const handleVillaClick = (villa) => {
//   //   if (!villa || !villa.center) return;

//   //   const fullVillaData = units.find((u) => u.code === villa.id);

//   //   setSearchParams({ unit: villa.code });
//   //   setSelectedVilla({ ...villa, ...(fullVillaData || {}) });

//   //   setIsAnimating(true);

//   //   // الزوم المطلوب عند التحديد هو 1.2 كما طلبتِ
//   //   const targetZoom = 1;

//   //   // حساب الموقع بحيث تكون الفيلا في منتصف الشاشة عرضاً، وتحت المنتصف طولاً (عشان الكارد)
//   //   const villaX = villa.center.x * targetZoom * (mapWidth / viewBoxWidth);
//   //   const villaY = villa.center.y * targetZoom * (mapHeight / viewBoxHeight);

//   //   const screenCenterX = window.innerWidth / 2;
//   //   const screenTargetY = window.innerHeight / 1.5; // الإزاحة لتحت

//   //   let newX = screenCenterX - villaX;
//   //   let newY = screenTargetY - villaY;

//   //   // قيود الحدود
//   //   const scaledW = mapWidth * targetZoom;
//   //   const scaledH = mapHeight * targetZoom;
//   //   const minX = window.innerWidth - scaledW;
//   //   const minY = window.innerHeight - scaledH;

//   //   newX = Math.max(Math.min(newX, 0), minX);
//   //   newY = Math.max(Math.min(newY, 0), minY);

//   //   // الأنميشن
//   //   const duration = 800;
//   //   const startTime = performance.now();
//   //   const startZoom = zoom;
//   //   const startX = pos.x;
//   //   const startY = pos.y;

//   //   const animate = (time) => {
//   //     const progress = Math.min((time - startTime) / duration, 1);
//   //     const ease = 1 - Math.pow(1 - progress, 3); // Smooth Out Cubic

//   //     setZoom(startZoom + (targetZoom - startZoom) * ease);
//   //     setPos({
//   //       x: startX + (newX - startX) * ease,
//   //       y: startY + (newY - startY) * ease,
//   //     });

//   //     if (progress < 1) {
//   //       requestAnimationFrame(animate);
//   //     } else {
//   //       setIsAnimating(false);
//   //     }
//   //   };
//   //   requestAnimationFrame(animate);
//   // };

//   const handleVillaMouseEnter = (villaId) => {
//     setHoveredVilla(villaId);
//   };
//   const handleVillaMouseLeave = () => {
//     setHoveredVilla(null);
//   };
//   // const handleMapClick = (e) => {
//   //   if (e.target.tagName !== "path") {
//   //     setSelectedVilla(null);
//   //     // setSearchParams({});
//   //   }
//   // };
//   const handleMapClick = (e) => {
//     // التأكد أن الضغطة ليست على مسار SVG (فيلا) وليست داخل الكارد
//     if (e.target.tagName !== "path" && !e.target.closest(".base-card-unit-")) {
//       setSelectedVilla(null);
//       setSearchParams({}, { replace: true }); // مسح الـ URL بأمان
//       didDebugFromUrl.current = false; // اسمحي له يقرأ من الـ URL تاني لو اليوزر اختار فيلا جديدة
//     }
//   };
//   // ------------------------------------------------------------------
//   // Mobile touch hook
//   // ------------------------------------------------------------------
//   const { onTouchStart, onTouchMove, onTouchEnd, onTouchCancel } =
//     useMobileTouch({
//       mapWidth,
//       mapHeight,
//       zoom,
//       setZoom,
//       setPos,
//       setDragging,
//       setVelocity,
//       dragging,
//       lastPos,
//       setLastPos,
//       velocity,
//       minZoom: 0.5,
//       maxZoom: 2,
//     });
//   useEffect(() => {
//     if (didDebugFromUrl.current) return;

//     const unitCode = searchParams.get("unit");
//     // console.log("[URL] unit param:", unitCode);

//     if (!unitCode) {
//       // console.warn("[URL] No unit in URL");
//       return;
//     }

//     if (!units.length) {
//       // console.warn("[DATA] units not loaded yet");
//       return;
//     }

//     const villa = units.find((u) => u.code === unitCode);

//     if (!villa) {
//       // console.error("[DATA] Villa not found in units:", unitCode);
//       return;
//     }

//     // ✅ الصح هنا
//     let center = villa.center;

//     if (!center) {
//       center = unitsSvgRef.current?.getCenterByCode(villa.code);
//     }

//     if (!center) {
//       // console.error("[DATA] Cannot resolve center for villa:", villa.code);
//       return;
//     }

//     didDebugFromUrl.current = true;

//     focusOnVilla({ ...villa, center });
//   }, [searchParams, units]);
//   // ... (داخل دالة MasterPlaneInner)

//   const focusOnVilla = (villa) => {
//     const fullVillaData = units.find((u) => u.code === villa.code);

//     setSelectedVilla({ ...villa, ...(fullVillaData || {}) });
//     setIsAnimating(true);

//     // زوم مناسب لرؤية التفاصيل والكارد
//     const targetZoom = 0.8;

//     const villaX = villa.center.x * targetZoom * (mapWidth / viewBoxWidth);
//     const villaY = villa.center.y * targetZoom * (mapHeight / viewBoxHeight);

//     const screenCenterX = window.innerWidth / 2;
//     // جعل الفيلا تظهر عند 75% من ارتفاع الشاشة (يعني نازلة لتحت)
//     const screenTargetY = window.innerHeight * 0.75;

//     let newX = screenCenterX - villaX;
//     let newY = screenTargetY - villaY;

//     const scaledW = mapWidth * targetZoom;
//     const scaledH = mapHeight * targetZoom;

//     // --- تعديل القيود (الـ Clamp) لفك القفل العلوي ---
//     const maxX = 0;
//     const maxY = 500; // السماح للماب بالنزول لأسفل بمقدار 500 بكسل
//     const minX = window.innerWidth - scaledW;
//     const minY = window.innerHeight - scaledH;

//     // تطبيق القيود الجديدة
//     newX = Math.max(Math.min(newX, maxX), minX);
//     newY = Math.max(Math.min(newY, maxY), minY);

//     const duration = 800;
//     const startTime = performance.now();
//     const startZoom = zoom;
//     const startX = pos.x;
//     const startY = pos.y;

//     const animate = (time) => {
//       const progress = Math.min((time - startTime) / duration, 1);
//       const ease = 1 - Math.pow(1 - progress, 3);

//       setZoom(startZoom + (targetZoom - startZoom) * ease);
//       setPos({
//         x: startX + (newX - startX) * ease,
//         y: startY + (newY - startY) * ease,
//       });

//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       } else {
//         setIsAnimating(false);
//       }
//     };

//     requestAnimationFrame(animate);
//   };
//   // const focusOnVilla = (villa) => {
//   //   // console.log("[FOCUS] start", {
//   //   //   code: villa.code,
//   //   //   center: villa.center,
//   //   //   zoom,
//   //   //   pos,
//   //   // });
//   //   const fullVillaData = units.find((u) => u.code === villa.code);

//   //   setSelectedVilla({ ...villa, ...(fullVillaData || {}) });
//   //   setIsAnimating(true);

//   //   const targetZoom = 0.5;

//   //   const villaX = villa.center.x * targetZoom * (mapWidth / viewBoxWidth);
//   //   const villaY = villa.center.y * targetZoom * (mapHeight / viewBoxHeight);

//   //   const screenCenterX = window.innerWidth / 2;
//   //   const screenTargetY = window.innerHeight / 1.5;

//   //   let newX = screenCenterX - villaX;
//   //   let newY = screenTargetY - villaY;

//   //   const scaledW = mapWidth * targetZoom;
//   //   const scaledH = mapHeight * targetZoom;
//   //   const minX = window.innerWidth - scaledW;
//   //   const minY = window.innerHeight - scaledH;

//   //   newX = Math.max(Math.min(newX, 0), minX);
//   //   newY = Math.max(Math.min(newY, 0), minY);

//   //   const duration = 800;
//   //   const startTime = performance.now();
//   //   const startZoom = zoom;
//   //   const startX = pos.x;
//   //   const startY = pos.y;

//   //   const animate = (time) => {
//   //     const progress = Math.min((time - startTime) / duration, 1);
//   //     const ease = 1 - Math.pow(1 - progress, 3);

//   //     setZoom(startZoom + (targetZoom - startZoom) * ease);
//   //     setPos({
//   //       x: startX + (newX - startX) * ease,
//   //       y: startY + (newY - startY) * ease,
//   //     });

//   //     if (progress < 1) {
//   //       requestAnimationFrame(animate);
//   //     } else {
//   //       setIsAnimating(false);
//   //     }
//   //   };

//   //   requestAnimationFrame(animate);
//   // };
//   const handleVillaClick = (villa) => {
//     if (!villa || !villa.center) return;

//     setSearchParams({ unit: villa.code });
//     focusOnVilla(villa);
//   };

//   // ------------------------------------------------------------------
//   // Render
//   // ------------------------------------------------------------------
//   return (
//     <div
//       id="map-container"
//       dir="ltr"
//       style={{
//         width: "100vw",
//         height: "100vh",
//         overflow: "hidden",
//         position: "relative",
//         cursor: dragging ? "grabbing" : "grab",
//         userSelect: "none",
//         touchAction: "none",
//       }}
//       onMouseDown={onMouseDown}
//       onMouseMove={onMouseMove}
//       onMouseUp={onMouseUp}
//       onMouseLeave={onMouseUp}
//       onTouchStart={onTouchStart}
//       onTouchMove={onTouchMove}
//       onTouchEnd={onTouchEnd}
//       onTouchCancel={onTouchCancel}
//       onClick={handleMapClick}
//     >
//       {/* {selectedVilla && console.log("[RENDER] selectedVilla", selectedVilla)} */}

//       <div
//         style={{
//           transform: `translate(${pos.x}px, ${pos.y}px) scale(${zoom})`,
//           transformOrigin: "top left",
//           willChange: "transform",
//           width: mapWidth,
//           height: mapHeight,
//         }}
//       >
//         {cachedVisibleTiles.map(({ tileKey, row, col }) => {
//           const img = imageCacheRef.current[tileKey];
//           if (!img) return null;
//           return (
//             <img
//               key={tileKey}
//               src={img.src}
//               alt=""
//               width={tileSize + 3}
//               height={tileSize + 3}
//               draggable="false"
//               style={{
//                 position: "absolute",
//                 left: col * tileSize,
//                 top: row * tileSize,
//                 // --- الإضافات الجديدة ---
//                 // imageRendering: "crisp-edges", // أو 'pixelated' لو الصور خرائط دقيقة
//                 // WebkitBackfaceVisibility: "hidden", // لمنع الرعشة أثناء الزوم
//                 // transform: "translateZ(0)", // إجبار المتصفح على استخدام كارت الشاشة GPU
//               }}
//             />
//             // <img
//             //   key={tileKey}
//             //   src={img.src}
//             //   alt=""
//             //   width={tileSize}
//             //   height={tileSize}
//             //   // width={tileSize + 4}
//             //   // height={tileSize + 4}
//             //   draggable="false"
//             //   style={{
//             //     position: "absolute",
//             //     left: col * tileSize,
//             //     top: row * tileSize,
//             //   }}
//             // />
//           );
//         })}
//       </div>

//       {/* Overlay SVGs */}
//       <div
//         style={{
//           position: "absolute",
//           left: pos.x,
//           top: pos.y,
//           width: mapWidth,
//           height: mapHeight,
//           transform: `scale(${zoom})`,
//           transformOrigin: "top left",
//           zIndex: 99,
//         }}
//       >
//         {!isOverlayHidden && (
//           <UnitsSvg
//             ref={unitsSvgRef}
//             mapWidth={mapWidth}
//             mapHeight={mapHeight}
//             clickableLayer={clickableLayerSvgString}
//             units={units}
//             hoveredVilla={hoveredVilla}
//             selectedVilla={selectedVilla}
//             onMouseEnter={handleVillaMouseEnter}
//             onMouseLeave={handleVillaMouseLeave}
//             onVillaClick={handleVillaClick}
//             activeTab={activeTab}
//             cancelledTypes={filterSelection?.cancelledTypes || []}
//             cancelledAvailability={filterSelection?.cancelledAvailability || []}
//             progressCategories={filterSelection?.progressCategories || []}
//             filters={filters}
//           />
//         )}
//       </div>

//       {/* Selected villa card */}
//       {selectedVilla && !isAnimating && (
//         <div
//           style={{
//             position: "fixed",
//             left:
//               pos.x + selectedVilla.center.x * zoom * (mapWidth / viewBoxWidth),
//             top:
//               pos.y +
//               selectedVilla.center.y * zoom * (mapHeight / viewBoxHeight),
//             zIndex: 99999,
//             transform: "translate(-50%, -110%)",
//           }}
//         >
//           <VillaCard
//             lang={lang}
//             page="master-plan"
//             width="340px"
//             villa={selectedVilla}
//             onShowProgress={setProgressVilla}
//             onOpenModal={() => {
//               setSpinVilla(selectedVilla);
//             }}
//           />
//         </div>
//       )}
//     </div>
//   );
// }

// function MasterPlane({
//   lang,
//   filterSelection,
//   isOverlayHidden,
//   filters,
//   setProgressVilla,
//   setSpinVilla,
// }) {
//   return (
//     <MasterPlaneInner
//       filterSelection={filterSelection}
//       isOverlayHidden={isOverlayHidden}
//       filters={filters}
//       lang={lang}
//       setProgressVilla={setProgressVilla}
//       setSpinVilla={setSpinVilla}
//     />
//   );
// }

// export default MasterPlane;
// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useZone } from "../../context/ZoneContext";
// import VillaCard from "../villacard/VillaCard";
// import useMobileTouch from "./mopile/useMopileTouch";
// import { useRangeFilter } from "../../context/rangeFilterContext";
// import UnitsSvg from "./svg/unitSvg";
// import { useTabsFilter } from "../../context/TabsFilterContext";
// import { useSearchParams } from "react-router-dom";

// function MasterPlaneInner({
//   setProgressVilla,
//   setSpinVilla,
//   filterSelection,
//   isOverlayHidden,
//   lang,
// }) {
//   const { filters } = useRangeFilter();
//   const { units = [], project: projectData } = useZone();
//   const clickableLayerSvgString = projectData?.clickable_layer || null;
//   const { activeTab } = useTabsFilter();
//   const [searchParams, setSearchParams] = useSearchParams();

//   const unitsSvgRef = useRef(null);
//   const canvasRef = useRef(null);
//   const imageCacheRef = useRef({});

//   // ------------------------------------------------------------------
//   // Tiles Map (background images)
//   // ------------------------------------------------------------------
//   const tilesMap = useMemo(() => {
//     if (!projectData?.building_images) return {};
//     const map = {};
//     projectData.building_images.forEach((item) => {
//       const match = item.image.match(/tile_(\d+)_(\d+)\.jpg$/);
//       if (match) {
//         const col = match[1];
//         const row = match[2];
//         map[`${col}-${row}`] = item.image;
//       }
//     });
//     return map;
//   }, [projectData]);

//   // ------------------------------------------------------------------
//   // Constants
//   // ------------------------------------------------------------------
//   const rows = 32;
//   const cols = 32;
//   const tileSize = 512;
//   const mapWidth = cols * tileSize;
//   const mapHeight = rows * tileSize;
//   const viewBoxWidth = 1638.4;
//   const viewBoxHeight = 1638.4;

//   // ------------------------------------------------------------------
//   // State
//   // ------------------------------------------------------------------
//   const [zoom, setZoom] = useState(1);
//   const [dragging, setDragging] = useState(false);
//   const [selectedVilla, setSelectedVilla] = useState(null);
//   const [hoveredVilla, setHoveredVilla] = useState(null);
//   const [minZoom, setMinZoom] = useState(1);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [velocity, setVelocity] = useState({ x: 0, y: 0 });
//   const [lastPos, setLastPos] = useState({ x: 0, y: 0 });
//   const didDebugFromUrl = useRef(false);

//   const initialZoom = Math.max(
//     window.innerWidth / mapWidth,
//     window.innerHeight / mapHeight
//   );

//   const [pos, setPos] = useState({
//     x: (window.innerWidth - mapWidth * initialZoom) / 2,
//     y: (window.innerHeight - mapHeight * initialZoom) / 2,
//   });

//   // ------------------------------------------------------------------
//   // Optimized Canvas Drawing Logic
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;
//     const ctx = canvas.getContext("2d");

//     // نحدث حجم الكانفاس ليكون بمساحة الشاشة فقط (للحفاظ على الخفة)
//     canvas.width = window.innerWidth;
//     canvas.height = window.innerHeight;

//     const render = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
      
//       const buffer = 1;
//       const startRow = Math.max(0, Math.floor(-pos.y / (tileSize * zoom)) - buffer);
//       const endRow = Math.min(rows, Math.ceil((window.innerHeight - pos.y) / (tileSize * zoom)) + buffer);
//       const startCol = Math.max(0, Math.floor(-pos.x / (tileSize * zoom)) - buffer);
//       const endCol = Math.min(cols, Math.ceil((window.innerWidth - pos.x) / (tileSize * zoom)) + buffer);

//       for (let row = startRow; row < endRow; row++) {
//         for (let col = startCol; col < endCol; col++) {
//           const tileKey = `${col}-${row}`;
//           const imagePath = tilesMap[tileKey];
//           if (!imagePath) continue;

//           let img = imageCacheRef.current[tileKey];
//           if (!img) {
//             img = new Image();
//             img.src = `https://api.gravity-proptech.com/public/storage/${imagePath}`;
//             img.onload = () => {
//               imageCacheRef.current[tileKey] = img;
//               // لا نحتاج لاستدعاء render هنا لأن useEffect سيعمل مع كل تغيير في pos
//             };
//           }

//           if (img && img.complete) {
//             // رسم التايل في مكانه الصحيح بالنسبة للشاشة
//             ctx.drawImage(
//               img,
//               col * tileSize * zoom + pos.x,
//               row * tileSize * zoom + pos.y,
//               tileSize * zoom + 1,
//               tileSize * zoom + 1
//             );
//           }
//         }
//       }
//     };

//     render();
//   }, [pos, zoom, tilesMap]);

//   // ------------------------------------------------------------------
//   // Interaction Handlers (Mouse & Touch)
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const newMinZoom = Math.max(window.innerWidth / mapWidth, window.innerHeight / mapHeight);
//     setMinZoom(newMinZoom);
//     setZoom(newMinZoom);
//     setPos({
//       x: (window.innerWidth - mapWidth * newMinZoom) / 2,
//       y: (window.innerHeight - mapHeight * newMinZoom) / 2,
//     });
//   }, []);

//   const onMouseDown = (e) => {
//     setDragging(true);
//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: 0, y: 0 });
//   };

//   const onMouseMove = (e) => {
//     if (!dragging) return;
//     const dx = e.clientX - lastPos.x;
//     const dy = e.clientY - lastPos.y;
//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: dx / 16, y: dy / 16 });
//     setPos((prev) => {
//       const scaledWidth = mapWidth * zoom;
//       const scaledHeight = mapHeight * zoom;
//       const maxX = 0;
//       const maxY = 0;
//       const minX = scaledWidth < window.innerWidth ? (window.innerWidth - scaledWidth) / 2 : -scaledWidth + window.innerWidth;
//       const minY = scaledHeight < window.innerHeight ? (window.innerHeight - scaledHeight) / 2 : -scaledHeight + window.innerHeight;
//       return {
//         x: Math.max(Math.min(prev.x + dx, maxX), minX),
//         y: Math.max(Math.min(prev.y + dy, maxY), minY),
//       };
//     });
//   };

//   const onMouseUp = () => {
//     if (!dragging) return;
//     setDragging(false);
//     let vx = velocity.x * 0.5;
//     let vy = velocity.y * 0.5;
//     const decay = 0.75;
//     const speedFactor = 15;
//     const animate = () => {
//       setPos((prev) => {
//         const scaledWidth = mapWidth * zoom;
//         const scaledHeight = mapHeight * zoom;
//         const maxX = 0;
//         const maxY = 0;
//         const minX = scaledWidth < window.innerWidth ? (window.innerWidth - scaledWidth) / 2 : -scaledWidth + window.innerWidth;
//         const minY = scaledHeight < window.innerHeight ? (window.innerHeight - scaledHeight) / 2 : -scaledHeight + window.innerHeight;
//         let newX = prev.x + vx * speedFactor;
//         let newY = prev.y + vy * speedFactor;
//         if (newX >= maxX || newX <= minX) vx = 0;
//         if (newY >= maxY || newY <= minY) vy = 0;
//         return { 
//             x: Math.max(Math.min(newX, maxX), minX), 
//             y: Math.max(Math.min(newY, maxY), minY) 
//         };
//       });
//       vx *= decay;
//       vy *= decay;
//       if (Math.abs(vx) > 0.01 || Math.abs(vy) > 0.01) {
//         requestAnimationFrame(animate);
//       }
//     };
//     requestAnimationFrame(animate);
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       const vw = window.innerWidth;
//       const vh = window.innerHeight;
//       const newMinZoom = Math.max(vw / mapWidth, vh / mapHeight);
//       setMinZoom(newMinZoom);
//       setZoom(prev => Math.max(prev, newMinZoom));
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const el = document.getElementById("map-container");
//     if (!el) return;
//     const handleWheel = (e) => {
//       e.preventDefault();
//       const scaleAmount = e.deltaY < 0 ? 1.1 : 0.9;
//       let newZoom = zoom * scaleAmount;
//       newZoom = Math.max(Math.min(newZoom, 2), minZoom);
//       const rect = el.getBoundingClientRect();
//       const mouseX = e.clientX - rect.left;
//       const mouseY = e.clientY - rect.top;
//       const zoomRatio = newZoom / zoom;
//       let newX = mouseX - (mouseX - pos.x) * zoomRatio;
//       let newY = mouseY - (mouseY - pos.y) * zoomRatio;
//       const scaledW = mapWidth * newZoom;
//       const scaledH = mapHeight * newZoom;
//       const minX = window.innerWidth - scaledW;
//       const minY = window.innerHeight - scaledH;
//       newX = scaledW < window.innerWidth ? (window.innerWidth - scaledW) / 2 : Math.max(Math.min(newX, 0), minX);
//       newY = scaledH < window.innerHeight ? (window.innerHeight - scaledH) / 2 : Math.max(Math.min(newY, 0), minY);
//       setZoom(newZoom);
//       setPos({ x: newX, y: newY });
//     };
//     el.addEventListener("wheel", handleWheel, { passive: false });
//     return () => el.removeEventListener("wheel", handleWheel);
//   }, [zoom, pos, minZoom]);

//   const handleVillaMouseEnter = (villaId) => setHoveredVilla(villaId);
//   const handleVillaMouseLeave = () => setHoveredVilla(null);
  
//   const handleMapClick = (e) => {
//     if (e.target.tagName !== "path" && !e.target.closest(".base-card-unit-")) {
//       setSelectedVilla(null);
//       setSearchParams({}, { replace: true });
//       didDebugFromUrl.current = false;
//     }
//   };

//   const { onTouchStart, onTouchMove, onTouchEnd, onTouchCancel } = useMobileTouch({
//     mapWidth, mapHeight, zoom, setZoom, setPos, setDragging, setVelocity, dragging, lastPos, setLastPos, velocity, minZoom, maxZoom: 2,
//   });

//   const focusOnVilla = (villa) => {
//     const fullVillaData = units.find((u) => u.code === villa.code);
//     setSelectedVilla({ ...villa, ...(fullVillaData || {}) });
//     setIsAnimating(true);
//     const targetZoom = 0.8;
//     const villaX = villa.center.x * targetZoom * (mapWidth / viewBoxWidth);
//     const villaY = villa.center.y * targetZoom * (mapHeight / viewBoxHeight);
//     const screenCenterX = window.innerWidth / 2;
//     const screenTargetY = window.innerHeight * 0.75;
//     let newX = screenCenterX - villaX;
//     let newY = screenTargetY - villaY;
//     const scaledW = mapWidth * targetZoom;
//     const scaledH = mapHeight * targetZoom;
//     newX = Math.max(Math.min(newX, 0), window.innerWidth - scaledW);
//     newY = Math.max(Math.min(newY, 0), window.innerHeight - scaledH);
    
//     const duration = 800;
//     const startTime = performance.now();
//     const startZoom = zoom;
//     const startX = pos.x;
//     const startY = pos.y;

//     const animate = (time) => {
//       const progress = Math.min((time - startTime) / duration, 1);
//       const ease = 1 - Math.pow(1 - progress, 3);
//       setZoom(startZoom + (targetZoom - startZoom) * ease);
//       setPos({
//         x: startX + (newX - startX) * ease,
//         y: startY + (newY - startY) * ease,
//       });
//       if (progress < 1) requestAnimationFrame(animate);
//       else setIsAnimating(false);
//     };
//     requestAnimationFrame(animate);
//   };

//   const handleVillaClick = (villa) => {
//     if (!villa || !villa.center) return;
//     setSearchParams({ unit: villa.code });
//     focusOnVilla(villa);
//   };
// useEffect(() => {
//   console.log('=== Render Trigger ===', {
//     pos: { x: pos.x.toFixed(2), y: pos.y.toFixed(2) },
//     zoom: zoom.toFixed(3),
//     // isDragging,
//     selectedVilla: selectedVilla?.code,
//     timestamp: Date.now()
//   });
// }, [pos, zoom, selectedVilla]);
//   return (
//     <div
//       id="map-container"
//       style={{
//         width: "100vw",
//         height: "100vh",
//         overflow: "hidden",
//         position: "relative",
//         cursor: dragging ? "grabbing" : "grab",
//         userSelect: "none",
//         touchAction: "none",
//         backgroundColor: "#f0f0f0"
//       }}
//       onMouseDown={onMouseDown}
//       onMouseMove={onMouseMove}
//       onMouseUp={onMouseUp}
//       onMouseLeave={onMouseUp}
//       onTouchStart={onTouchStart}
//       onTouchMove={onTouchMove}
//       onTouchEnd={onTouchEnd}
//       onTouchCancel={onTouchCancel}
//       onClick={handleMapClick}
//     >
//       {/* الكانفاس بمساحة الشاشة فقط ولكنه ثابت Position Fixed */}
//       <canvas
//         ref={canvasRef}
//         style={{
//           position: "absolute",
//           left: 0,
//           top: 0,
//           width: "100%",
//           height: "100%",
//           display: "block",
//           imageRendering: "crisp-edges",
//           pointerEvents: "none"
//         }}
//       />

//       {/* الـ SVG يتحرك بـ CSS Transform مما يضمن سلاسة الحركة وعدم الاهتزاز */}
//       <div
//         style={{
//           position: "absolute",
//           left: pos.x,
//           top: pos.y,
//           width: mapWidth,
//           height: mapHeight,
//           transform: `scale(${zoom})`,
//           transformOrigin: "top left",
//           zIndex: 99,
//           pointerEvents: "none",
//           willChange: "transform"
//         }}
//       >
//         <div style={{ pointerEvents: "auto", width: "100%", height: "100%" }}>
//           {!isOverlayHidden && (
//             <UnitsSvg
//               ref={unitsSvgRef}
//               mapWidth={mapWidth}
//               mapHeight={mapHeight}
//               clickableLayer={clickableLayerSvgString}
//               units={units}
//               hoveredVilla={hoveredVilla}
//               selectedVilla={selectedVilla}
//               onMouseEnter={handleVillaMouseEnter}
//               onMouseLeave={handleVillaMouseLeave}
//               onVillaClick={handleVillaClick}
//               activeTab={activeTab}
//               cancelledTypes={filterSelection?.cancelledTypes || []}
//               cancelledAvailability={filterSelection?.cancelledAvailability || []}
//               progressCategories={filterSelection?.progressCategories || []}
//               filters={filters}
//             />
//           )}
//         </div>
//       </div>

//       {/* Villa Card */}
//       {selectedVilla && !isAnimating && (
//         <div
//           style={{
//             position: "fixed",
//             left: pos.x + selectedVilla.center.x * zoom * (mapWidth / viewBoxWidth),
//             top: pos.y + selectedVilla.center.y * zoom * (mapHeight / viewBoxHeight),
//             zIndex: 99999,
//             transform: "translate(-50%, -110%)",
//             pointerEvents: "auto"
//           }}
//         >
//           <VillaCard
//             lang={lang}
//             page="master-plan"
//             width="340px"
//             villa={selectedVilla}
//             onShowProgress={setProgressVilla}
//             onOpenModal={() => setSpinVilla(selectedVilla)}
//           />
//         </div>
//       )}
//     </div>
//   );
// }

// function MasterPlane({ lang, filterSelection, isOverlayHidden, filters, setProgressVilla, setSpinVilla }) {
//   return (
//     <MasterPlaneInner
//       filterSelection={filterSelection}
//       isOverlayHidden={isOverlayHidden}
//       filters={filters}
//       lang={lang}
//       setProgressVilla={setProgressVilla}
//       setSpinVilla={setSpinVilla}
//     />
//   );
// }

// export default MasterPlane;


// كانفس سريع ولكن الكمارد مبقاش يظهر
// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useZone } from "../../context/ZoneContext";
// import VillaCard from "../villacard/VillaCard";
// import useMobileTouch from "./mopile/useMopileTouch";
// import { useRangeFilter } from "../../context/rangeFilterContext";
// import UnitsSvg from "./svg/unitSvg";
// import { useTabsFilter } from "../../context/TabsFilterContext";
// import { useSearchParams } from "react-router-dom";

// function MasterPlaneInner({
//   setProgressVilla,
//   setSpinVilla,
//   filterSelection,
//   isOverlayHidden,
//   lang,
// }) {
//   const { filters } = useRangeFilter();
//   const { units = [], project: projectData } = useZone();
//   const clickableLayerSvgString = projectData?.clickable_layer || null;
//   const { activeTab } = useTabsFilter();
//   const [searchParams, setSearchParams] = useSearchParams();

//   // Refs
//   const unitsSvgRef = useRef(null);
//   const canvasRef = useRef(null);
//   const svgWrapperRef = useRef(null);
//   const villaCardRef = useRef(null);
//   const imageCacheRef = useRef({});

//   // ------------------------------------------------------------------
//   // Tiles Map (background images)
//   // ------------------------------------------------------------------
//   const tilesMap = useMemo(() => {
//     if (!projectData?.building_images) return {};
//     const map = {};
//     projectData.building_images.forEach((item) => {
//       const match = item.image.match(/tile_(\d+)_(\d+)\.jpg$/);
//       if (match) {
//         const col = match[1];
//         const row = match[2];
//         map[`${col}-${row}`] = item.image;
//       }
//     });
//     return map;
//   }, [projectData]);

//   // ------------------------------------------------------------------
//   // Constants
//   // ------------------------------------------------------------------
//   const rows = 32;
//   const cols = 32;
//   const tileSize = 512;
//   const mapWidth = cols * tileSize;
//   const mapHeight = rows * tileSize;
//   const viewBoxWidth = 1638.4;
//   const viewBoxHeight = 1638.4;

//   // ------------------------------------------------------------------
//   // State
//   // ------------------------------------------------------------------
//   const [zoom, setZoom] = useState(1);
//   const [dragging, setDragging] = useState(false);
//   const [selectedVilla, setSelectedVilla] = useState(null);
//   const [hoveredVilla, setHoveredVilla] = useState(null);
//   const [minZoom, setMinZoom] = useState(1);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [velocity, setVelocity] = useState({ x: 0, y: 0 });
//   const [lastPos, setLastPos] = useState({ x: 0, y: 0 });
//   const didDebugFromUrl = useRef(false);

//   const initialZoom = Math.max(
//     window.innerWidth / mapWidth,
//     window.innerHeight / mapHeight
//   );

//   const [pos, setPos] = useState({
//     x: (window.innerWidth - mapWidth * initialZoom) / 2,
//     y: (window.innerHeight - mapHeight * initialZoom) / 2,
//   });

//   // ------------------------------------------------------------------
//   // Optimized Canvas Drawing Logic
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;
//     const ctx = canvas.getContext("2d");

//     canvas.width = window.innerWidth;
//     canvas.height = window.innerHeight;

//     const render = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
      
//       const buffer = 1;
//       const startRow = Math.max(0, Math.floor(-pos.y / (tileSize * zoom)) - buffer);
//       const endRow = Math.min(rows, Math.ceil((window.innerHeight - pos.y) / (tileSize * zoom)) + buffer);
//       const startCol = Math.max(0, Math.floor(-pos.x / (tileSize * zoom)) - buffer);
//       const endCol = Math.min(cols, Math.ceil((window.innerWidth - pos.x) / (tileSize * zoom)) + buffer);

//       for (let row = startRow; row < endRow; row++) {
//         for (let col = startCol; col < endCol; col++) {
//           const tileKey = `${col}-${row}`;
//           const imagePath = tilesMap[tileKey];
//           if (!imagePath) continue;

//           let img = imageCacheRef.current[tileKey];
//           if (!img) {
//             img = new Image();
//             img.src = `https://api.gravity-proptech.com/public/storage/${imagePath}`;
//             img.onload = () => {
//               imageCacheRef.current[tileKey] = img;
//             };
//           }

//           if (img && img.complete) {
//             ctx.drawImage(
//               img,
//               col * tileSize * zoom + pos.x,
//               row * tileSize * zoom + pos.y,
//               tileSize * zoom + 1,
//               tileSize * zoom + 1
//             );
//           }
//         }
//       }
//     };

//     render();
//   }, [pos, zoom, tilesMap]);

//   // ------------------------------------------------------------------
//   // Direct Transform Control for SVG Wrapper (أهم تعديل لإصلاح الاهتزاز)
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const wrapper = svgWrapperRef.current;
//     if (!wrapper) return;

//     wrapper.style.transform = `translate(${pos.x}px, ${pos.y}px) scale(${zoom})`;
//     wrapper.style.transformOrigin = "top left";
//   }, [pos.x, pos.y, zoom]);

//   // ------------------------------------------------------------------
//   // Direct Transform Control for Villa Card
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const card = villaCardRef.current;
//     if (!card || !selectedVilla || isAnimating) return;

//     const scaleFactor = mapWidth / viewBoxWidth;
//     const villaScreenX = selectedVilla.center.x * scaleFactor;
//     const villaScreenY = selectedVilla.center.y * scaleFactor;

//     card.style.transform = `
//       translate(${pos.x + villaScreenX}px, ${pos.y + villaScreenY}px) 
//       scale(${zoom}) 
//       translate(-50%, -110%)
//     `;
//   }, [pos.x, pos.y, zoom, selectedVilla, isAnimating, mapWidth, viewBoxWidth]);

//   // ------------------------------------------------------------------
//   // Interaction Handlers (Mouse & Touch)
//   // ------------------------------------------------------------------
//   useEffect(() => {
//     const newMinZoom = Math.max(window.innerWidth / mapWidth, window.innerHeight / mapHeight);
//     setMinZoom(newMinZoom);
//     setZoom(newMinZoom);
//     setPos({
//       x: (window.innerWidth - mapWidth * newMinZoom) / 2,
//       y: (window.innerHeight - mapHeight * newMinZoom) / 2,
//     });
//   }, []);

//   const onMouseDown = (e) => {
//     setDragging(true);
//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: 0, y: 0 });
//   };

//   const onMouseMove = (e) => {
//     if (!dragging) return;
//     const dx = e.clientX - lastPos.x;
//     const dy = e.clientY - lastPos.y;
//     setLastPos({ x: e.clientX, y: e.clientY });
//     setVelocity({ x: dx / 16, y: dy / 16 });

//     setPos((prev) => {
//       const scaledWidth = mapWidth * zoom;
//       const scaledHeight = mapHeight * zoom;
//       const maxX = 0;
//       const maxY = 0;
//       const minX = scaledWidth < window.innerWidth ? (window.innerWidth - scaledWidth) / 2 : -scaledWidth + window.innerWidth;
//       const minY = scaledHeight < window.innerHeight ? (window.innerHeight - scaledHeight) / 2 : -scaledHeight + window.innerHeight;

//       return {
//         x: Math.max(Math.min(prev.x + dx, maxX), minX),
//         y: Math.max(Math.min(prev.y + dy, maxY), minY),
//       };
//     });
//   };

//   const onMouseUp = () => {
//     if (!dragging) return;
//     setDragging(false);

//     let vx = velocity.x * 0.5;
//     let vy = velocity.y * 0.5;
//     const decay = 0.75;
//     const speedFactor = 15;

//     const animate = () => {
//       setPos((prev) => {
//         const scaledWidth = mapWidth * zoom;
//         const scaledHeight = mapHeight * zoom;
//         const maxX = 0;
//         const maxY = 0;
//         const minX = scaledWidth < window.innerWidth ? (window.innerWidth - scaledWidth) / 2 : -scaledWidth + window.innerWidth;
//         const minY = scaledHeight < window.innerHeight ? (window.innerHeight - scaledHeight) / 2 : -scaledHeight + window.innerHeight;

//         let newX = prev.x + vx * speedFactor;
//         let newY = prev.y + vy * speedFactor;

//         if (newX >= maxX || newX <= minX) vx = 0;
//         if (newY >= maxY || newY <= minY) vy = 0;

//         return { 
//           x: Math.max(Math.min(newX, maxX), minX), 
//           y: Math.max(Math.min(newY, maxY), minY) 
//         };
//       });

//       vx *= decay;
//       vy *= decay;

//       if (Math.abs(vx) > 0.01 || Math.abs(vy) > 0.01) {
//         requestAnimationFrame(animate);
//       }
//     };

//     requestAnimationFrame(animate);
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       const vw = window.innerWidth;
//       const vh = window.innerHeight;
//       const newMinZoom = Math.max(vw / mapWidth, vh / mapHeight);
//       setMinZoom(newMinZoom);
//       setZoom((prev) => Math.max(prev, newMinZoom));
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const el = document.getElementById("map-container");
//     if (!el) return;

//     const handleWheel = (e) => {
//       e.preventDefault();
//       const scaleAmount = e.deltaY < 0 ? 1.1 : 0.9;
//       let newZoom = zoom * scaleAmount;
//       newZoom = Math.max(Math.min(newZoom, 2), minZoom);

//       const rect = el.getBoundingClientRect();
//       const mouseX = e.clientX - rect.left;
//       const mouseY = e.clientY - rect.top;

//       const zoomRatio = newZoom / zoom;
//       let newX = mouseX - (mouseX - pos.x) * zoomRatio;
//       let newY = mouseY - (mouseY - pos.y) * zoomRatio;

//       const scaledW = mapWidth * newZoom;
//       const scaledH = mapHeight * newZoom;

//       const minX = window.innerWidth - scaledW;
//       const minY = window.innerHeight - scaledH;

//       newX = scaledW < window.innerWidth 
//         ? (window.innerWidth - scaledW) / 2 
//         : Math.max(Math.min(newX, 0), minX);
      
//       newY = scaledH < window.innerHeight 
//         ? (window.innerHeight - scaledH) / 2 
//         : Math.max(Math.min(newY, 0), minY);

//       setZoom(newZoom);
//       setPos({ x: newX, y: newY });
//     };

//     el.addEventListener("wheel", handleWheel, { passive: false });
//     return () => el.removeEventListener("wheel", handleWheel);
//   }, [zoom, pos, minZoom]);

//   const handleVillaMouseEnter = (villaId) => setHoveredVilla(villaId);
//   const handleVillaMouseLeave = () => setHoveredVilla(null);
  
//   const handleMapClick = (e) => {
//     if (e.target.tagName !== "path" && !e.target.closest(".base-card-unit-")) {
//       setSelectedVilla(null);
//       setSearchParams({}, { replace: true });
//       didDebugFromUrl.current = false;
//     }
//   };

//   const { onTouchStart, onTouchMove, onTouchEnd, onTouchCancel } = useMobileTouch({
//     mapWidth, 
//     mapHeight, 
//     zoom, 
//     setZoom, 
//     setPos, 
//     setDragging, 
//     setVelocity, 
//     dragging, 
//     lastPos, 
//     setLastPos, 
//     velocity, 
//     minZoom, 
//     maxZoom: 2,
//   });

//   const focusOnVilla = (villa) => {
//     const fullVillaData = units.find((u) => u.code === villa.code);
//     setSelectedVilla({ ...villa, ...(fullVillaData || {}) });
//     setIsAnimating(true);

//     const targetZoom = 0.8;
//     const villaX = villa.center.x * targetZoom * (mapWidth / viewBoxWidth);
//     const villaY = villa.center.y * targetZoom * (mapHeight / viewBoxHeight);
    
//     const screenCenterX = window.innerWidth / 2;
//     const screenTargetY = window.innerHeight * 0.75;

//     let newX = screenCenterX - villaX;
//     let newY = screenTargetY - villaY;

//     const scaledW = mapWidth * targetZoom;
//     const scaledH = mapHeight * targetZoom;

//     newX = Math.max(Math.min(newX, 0), window.innerWidth - scaledW);
//     newY = Math.max(Math.min(newY, 0), window.innerHeight - scaledH);
    
//     const duration = 800;
//     const startTime = performance.now();
//     const startZoom = zoom;
//     const startX = pos.x;
//     const startY = pos.y;

//     const animate = (time) => {
//       const progress = Math.min((time - startTime) / duration, 1);
//       const ease = 1 - Math.pow(1 - progress, 3);

//       setZoom(startZoom + (targetZoom - startZoom) * ease);
//       setPos({
//         x: startX + (newX - startX) * ease,
//         y: startY + (newY - startY) * ease,
//       });

//       if (progress < 1) {
//         requestAnimationFrame(animate);
//       } else {
//         setIsAnimating(false);
//       }
//     };

//     requestAnimationFrame(animate);
//   };

//   const handleVillaClick = (villa) => {
//     if (!villa || !villa.center) return;
//     setSearchParams({ unit: villa.code });
//     focusOnVilla(villa);
//   };

//   return (
//     <div
//       id="map-container"
//       style={{
//         width: "100vw",
//         height: "100vh",
//         overflow: "hidden",
//         position: "relative",
//         cursor: dragging ? "grabbing" : "grab",
//         userSelect: "none",
//         touchAction: "none",
//         backgroundColor: "#f0f0f0"
//       }}
//       onMouseDown={onMouseDown}
//       onMouseMove={onMouseMove}
//       onMouseUp={onMouseUp}
//       onMouseLeave={onMouseUp}
//       onTouchStart={onTouchStart}
//       onTouchMove={onTouchMove}
//       onTouchEnd={onTouchEnd}
//       onTouchCancel={onTouchCancel}
//       onClick={handleMapClick}
//     >
//       {/* Canvas Layer - Background Tiles */}
//       <canvas
//         ref={canvasRef}
//         style={{
//           position: "absolute",
//           left: 0,
//           top: 0,
//           width: "100%",
//           height: "100%",
//           display: "block",
//           imageRendering: "crisp-edges",
//           pointerEvents: "none"
//         }}
//       />

//       {/* SVG Layer - Units (مُحسّن لعدم الاهتزاز) */}
//       <div
//         ref={svgWrapperRef}
//         style={{
//           position: "absolute",
//           left: 0,
//           top: 0,
//           width: mapWidth,
//           height: mapHeight,
//           zIndex: 99,
//           pointerEvents: "none",
//           willChange: "transform",
//           contain: "layout style paint",
//         }}
//       >
//         <div style={{ pointerEvents: "auto", width: "100%", height: "100%" }}>
//           {!isOverlayHidden && (
//             <UnitsSvg
//               ref={unitsSvgRef}
//               mapWidth={mapWidth}
//               mapHeight={mapHeight}
//               clickableLayer={clickableLayerSvgString}
//               units={units}
//               hoveredVilla={hoveredVilla}
//               selectedVilla={selectedVilla}
//               onMouseEnter={handleVillaMouseEnter}
//               onMouseLeave={handleVillaMouseLeave}
//               onVillaClick={handleVillaClick}
//               activeTab={activeTab}
//               cancelledTypes={filterSelection?.cancelledTypes || []}
//               cancelledAvailability={filterSelection?.cancelledAvailability || []}
//               progressCategories={filterSelection?.progressCategories || []}
//               filters={filters}
//             />
//           )}
//         </div>
//       </div>

//       {/* Villa Card - Positioned with direct transform */}
//       {selectedVilla && !isAnimating && (
//         <div
//           ref={villaCardRef}
//           style={{
//             position: "absolute",
//             left: 0,
//             top: 0,
//             zIndex: 99999,
//             pointerEvents: "auto",
//             willChange: "transform",
//             contain: "layout style paint",
//           }}
//         >
//           <VillaCard
//             lang={lang}
//             page="master-plan"
//             width="340px"
//             villa={selectedVilla}
//             onShowProgress={setProgressVilla}
//             onOpenModal={() => setSpinVilla(selectedVilla)}
//           />
//         </div>
//       )}
//     </div>
//   );
// }

// function MasterPlane({ lang, filterSelection, isOverlayHidden, filters, setProgressVilla, setSpinVilla }) {
//   return (
//     <MasterPlaneInner
//       filterSelection={filterSelection}
//       isOverlayHidden={isOverlayHidden}
//       filters={filters}
//       lang={lang}
//       setProgressVilla={setProgressVilla}
//       setSpinVilla={setSpinVilla}
//     />
//   );
// }

// export default MasterPlane;






















import React, { useState, useEffect, useMemo, useRef } from "react";
import { useZone } from "../../context/ZoneContext";
import VillaCard from "../villacard/VillaCard";
import useMobileTouch from "./mopile/useMopileTouch";
import { useRangeFilter } from "../../context/rangeFilterContext";
import UnitsSvg from "./svg/unitSvg";
import { useTabsFilter } from "../../context/TabsFilterContext";
import { useSearchParams } from "react-router-dom";

function MasterPlaneInner({
  setProgressVilla,
  setSpinVilla,
  filterSelection,
  isOverlayHidden,
  lang,
}) {
  const { filters } = useRangeFilter();
  const { units = [], project: projectData } = useZone();
  const clickableLayerSvgString = projectData?.clickable_layer || null;
  const { activeTab } = useTabsFilter();
  const [searchParams, setSearchParams] = useSearchParams();

  const unitsSvgRef = useRef(null);
  const canvasRef = useRef(null); // Ref للكانفاس الجديد

  // ------------------------------------------------------------------
  // Tiles Map (background images)
  // ------------------------------------------------------------------
  const tilesMap = useMemo(() => {
    if (!projectData?.building_images) return {};

    const map = {};
    projectData.building_images.forEach((item) => {
      const match = item.image.match(/tile_(\d+)_(\d+)\.jpg$/);
      if (match) {
        const col = match[1];
        const row = match[2];
        map[`${col}-${row}`] = item.image;
      }
    });
    return map;
  }, [projectData]);

  // ------------------------------------------------------------------
  // Constants
  // ------------------------------------------------------------------
  const rows = 32;
  const cols = 32;
  const tileSize = 512;

  const mapWidth = cols * tileSize;
  const mapHeight = rows * tileSize;
  const viewBoxWidth = 1638.4;
  const viewBoxHeight = 1638.4;

  // ------------------------------------------------------------------
  // State
  // ------------------------------------------------------------------
  const [zoom, setZoom] = useState(1);
  const [dragging, setDragging] = useState(false);
  const [selectedVilla, setSelectedVilla] = useState(null);
  const [hoveredVilla, setHoveredVilla] = useState(null);
  const [minZoom, setMinZoom] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false);
  const [velocity, setVelocity] = useState({ x: 0, y: 0 });
  const [lastPos, setLastPos] = useState({ x: 0, y: 0 });
  const [loadedTiles, setLoadedTiles] = useState(new Set());
  const didDebugFromUrl = useRef(false);

  const initialZoom = Math.max(
    window.innerWidth / mapWidth,
    window.innerHeight / mapHeight
  );

  const [pos, setPos] = useState({
    x: (window.innerWidth - mapWidth * initialZoom) / 2,
    y: (window.innerHeight - mapHeight * initialZoom) / 2,
  });

  const loadedTilesRef = useRef(new Set());
  const imageCacheRef = useRef({});

  // ------------------------------------------------------------------
  // Canvas Drawing Logic (The Core Update)
  // ------------------------------------------------------------------
  const cachedVisibleTiles = useMemo(() => {
    const tiles = [];
    const buffer = 1;

    const startRow = Math.max(0, Math.floor(-pos.y / (tileSize * zoom)) - buffer);
    const endRow = Math.min(rows, Math.ceil((window.innerHeight - pos.y) / (tileSize * zoom)) + buffer);
    const startCol = Math.max(0, Math.floor(-pos.x / (tileSize * zoom)) - buffer);
    const endCol = Math.min(cols, Math.ceil((window.innerWidth - pos.x) / (tileSize * zoom)) + buffer);

    for (let row = startRow; row < endRow; row++) {
      for (let col = startCol; col < endCol; col++) {
        const tileKey = `${col}-${row}`;
        const imagePath = tilesMap[tileKey];
        if (!imagePath) continue;
        tiles.push({ tileKey, row, col, imagePath });
      }
    }
    return tiles;
  }, [pos.x, pos.y, zoom, tilesMap]);

  // رسم الكانفاس
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    // تنظيف الكانفاس قبل الرسم الجديد
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    cachedVisibleTiles.forEach(({ tileKey, row, col, imagePath }) => {
      let img = imageCacheRef.current[tileKey];

      if (!img) {
        img = new Image();
        img.src = `https://api.gravity-proptech.com/public/storage/${imagePath}`;
        img.onload = () => {
          // إعادة الرسم بمجرد تحميل الصورة
          drawTile(ctx, img, col, row);
        };
        imageCacheRef.current[tileKey] = img;
      } else if (img.complete) {
        drawTile(ctx, img, col, row);
      }
    });

    function drawTile(context, image, c, r) {
      // الرسم بنفس حسابات التموضع الأصلية لضمان عدم الاهتزاز
      // نضرب في tileSize + 1 لضمان عدم وجود فواصل بيضاء (Seams)
      context.drawImage(
        image,
        c * tileSize,
        r * tileSize,
        tileSize + 1,
        tileSize + 1
      );
    }
  }, [cachedVisibleTiles, zoom]);

  // ------------------------------------------------------------------
  // Initial setup & resize handling
  // ------------------------------------------------------------------
  useEffect(() => {
    const newMinZoom = Math.max(
      window.innerWidth / mapWidth,
      window.innerHeight / mapHeight
    );
    setMinZoom(newMinZoom);
    setZoom(newMinZoom);
    setPos({
      x: (window.innerWidth - mapWidth * newMinZoom) / 2,
      y: (window.innerHeight - mapHeight * newMinZoom) / 2,
    });
  }, []);

  const onMouseDown = (e) => {
    setDragging(true);
    setLastPos({ x: e.clientX, y: e.clientY });
    setVelocity({ x: 0, y: 0 });
  };

  const onMouseMove = (e) => {
    if (!dragging) return;
    const dx = e.clientX - lastPos.x;
    const dy = e.clientY - lastPos.y;
    setLastPos({ x: e.clientX, y: e.clientY });
    setVelocity({ x: dx / 16, y: dy / 16 });
    setPos((prev) => {
      const scaledWidth = mapWidth * zoom;
      const scaledHeight = mapHeight * zoom;
      const maxX = 0;
      const maxY = 0;
      const minX = scaledWidth < window.innerWidth ? (window.innerWidth - scaledWidth) / 2 : -scaledWidth + window.innerWidth;
      const minY = scaledHeight < window.innerHeight ? (window.innerHeight - scaledHeight) / 2 : -scaledHeight + window.innerHeight;
      let newX = prev.x + dx;
      let newY = prev.y + dy;
      return {
        x: Math.max(Math.min(newX, maxX), minX),
        y: Math.max(Math.min(newY, maxY), minY),
      };
    });
  };

  const onMouseUp = () => {
    if (!dragging) return;
    setDragging(false);
    let vx = velocity.x * 0.5;
    let vy = velocity.y * 0.5;
    const decay = 0.75;
    const speedFactor = 15;
    const animate = () => {
      setPos((prev) => {
        const scaledWidth = mapWidth * zoom;
        const scaledHeight = mapHeight * zoom;
        const maxX = 0;
        const maxY = 0;
        const minX = scaledWidth < window.innerWidth ? (window.innerWidth - scaledWidth) / 2 : -scaledWidth + window.innerWidth;
        const minY = scaledHeight < window.innerHeight ? (window.innerHeight - scaledHeight) / 2 : -scaledHeight + window.innerHeight;
        let newX = prev.x + vx * speedFactor;
        let newY = prev.y + vy * speedFactor;
        if (newX >= maxX || newX <= minX) vx = 0;
        if (newY >= maxY || newY <= minY) vy = 0;
        newX = Math.max(Math.min(newX, maxX), minX);
        newY = Math.max(Math.min(newY, maxY), minY);
        return { x: newX, y: newY };
      });
      vx *= decay;
      vy *= decay;
      if (Math.abs(vx) > 0.01 || Math.abs(vy) > 0.01) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  };

  useEffect(() => {
    const handleResize = () => {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const newMinZoom = Math.max(vw / mapWidth, vh / mapHeight);
      setMinZoom(newMinZoom);

      if (selectedVilla) {
        setPos(() => {
          const villaX = selectedVilla.center.x * zoom * (mapWidth / viewBoxWidth);
          const villaY = selectedVilla.center.y * zoom * (mapHeight / viewBoxHeight);
          let newX = vw / 2 - villaX;
          let newY = vh / 1.5 - villaY;
          const scaledW = mapWidth * zoom;
          const scaledH = mapHeight * zoom;
          const minX = vw - scaledW;
          const minY = vh - scaledH;
          newX = scaledW < vw ? (vw - scaledW) / 2 : Math.max(Math.min(newX, 0), minX);
          newY = scaledH < vh ? (vh - scaledH) / 2 : Math.max(Math.min(newY, 0), minY);
          return { x: newX, y: newY };
        });
      } else {
        setZoom(newMinZoom);
        setPos({
          x: (vw - mapWidth * newMinZoom) / 2,
          y: (vh - mapHeight * newMinZoom) / 2,
        });
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [selectedVilla, zoom, mapWidth, mapHeight]);

  useEffect(() => {
    const el = document.getElementById("map-container");
    if (!el) return;
    const handleWheel = (e) => {
      e.preventDefault();
      const scaleAmount = e.deltaY < 0 ? 1.1 : 0.9;
      let newZoom = zoom * scaleAmount;
      newZoom = Math.max(Math.min(newZoom, 2), minZoom);
      const rect = el.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;
      const zoomRatio = newZoom / zoom;
      let newX = mouseX - (mouseX - pos.x) * zoomRatio;
      let newY = mouseY - (mouseY - pos.y) * zoomRatio;
      const scaledW = mapWidth * newZoom;
      const scaledH = mapHeight * newZoom;
      const minX = window.innerWidth - scaledW;
      const minY = window.innerHeight - scaledH;
      newX = scaledW < window.innerWidth ? (window.innerWidth - scaledW) / 2 : Math.max(Math.min(newX, 0), minX);
      newY = scaledH < window.innerHeight ? (window.innerHeight - scaledH) / 2 : Math.max(Math.min(newY, 0), minY);
      setZoom(newZoom);
      setPos({ x: newX, y: newY });
    };
    el.addEventListener("wheel", handleWheel, { passive: false });
    return () => el.removeEventListener("wheel", handleWheel);
  }, [zoom, pos, minZoom, mapWidth, mapHeight]);

  const handleVillaMouseEnter = (villaId) => setHoveredVilla(villaId);
  const handleVillaMouseLeave = () => setHoveredVilla(null);
  const handleMapClick = (e) => {
    if (e.target.tagName !== "path" && !e.target.closest(".base-card-unit-")) {
      setSelectedVilla(null);
      setSearchParams({}, { replace: true });
      didDebugFromUrl.current = false;
    }
  };

  const { onTouchStart, onTouchMove, onTouchEnd, onTouchCancel } = useMobileTouch({
    mapWidth, mapHeight, zoom, setZoom, setPos, setDragging, setVelocity, dragging, lastPos, setLastPos, velocity, minZoom: 0.5, maxZoom: 2,
  });

  useEffect(() => {
    if (didDebugFromUrl.current) return;
    const unitCode = searchParams.get("unit");
    if (!unitCode || !units.length) return;
    const villa = units.find((u) => u.code === unitCode);
    if (!villa) return;
    let center = villa.center || unitsSvgRef.current?.getCenterByCode(villa.code);
    if (!center) return;
    didDebugFromUrl.current = true;
    focusOnVilla({ ...villa, center });
  }, [searchParams, units]);

  const focusOnVilla = (villa) => {
    const fullVillaData = units.find((u) => u.code === villa.code);
    setSelectedVilla({ ...villa, ...(fullVillaData || {}) });
    setIsAnimating(true);
    const targetZoom = 0.8;
    const villaX = villa.center.x * targetZoom * (mapWidth / viewBoxWidth);
    const villaY = villa.center.y * targetZoom * (mapHeight / viewBoxHeight);
    const screenCenterX = window.innerWidth / 2;
    const screenTargetY = window.innerHeight * 0.75;
    let newX = screenCenterX - villaX;
    let newY = screenTargetY - villaY;
    const scaledW = mapWidth * targetZoom;
    const scaledH = mapHeight * targetZoom;
    const maxX = 0;
    const maxY = 500;
    const minX = window.innerWidth - scaledW;
    const minY = window.innerHeight - scaledH;
    newX = Math.max(Math.min(newX, maxX), minX);
    newY = Math.max(Math.min(newY, maxY), minY);
    const duration = 800;
    const startTime = performance.now();
    const startZoom = zoom;
    const startX = pos.x;
    const startY = pos.y;
    const animate = (time) => {
      const progress = Math.min((time - startTime) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      setZoom(startZoom + (targetZoom - startZoom) * ease);
      setPos({
        x: startX + (newX - startX) * ease,
        y: startY + (newY - startY) * ease,
      });
      if (progress < 1) requestAnimationFrame(animate);
      else setIsAnimating(false);
    };
    requestAnimationFrame(animate);
  };

  const handleVillaClick = (villa) => {
    if (!villa || !villa.center) return;
    setSearchParams({ unit: villa.code });
    focusOnVilla(villa);
  };

  return (
    <div
      id="map-container"
      dir="ltr"
      style={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
        cursor: dragging ? "grabbing" : "grab",
        userSelect: "none",
        touchAction: "none",
      }}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseUp}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onTouchCancel={onTouchCancel}
      onClick={handleMapClick}
    >
      {/* Canvas Layer Replacing 1000s of <img> tags */}
      <div
        style={{
          transform: `translate(${pos.x}px, ${pos.y}px) scale(${zoom})`,
          transformOrigin: "top left",
          willChange: "transform",
          width: mapWidth,
          height: mapHeight,
        }}
      >
        <canvas
          ref={canvasRef}
          width={mapWidth}
          height={mapHeight}
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            display: "block",
            imageRendering: "crisp-edges",
          }}
        />
      </div>

      {/* Overlay SVGs - المحرك الأساسي (pos و zoom) متطابق تماماً لضمان الثبات */}
      <div
        style={{
          position: "absolute",
          left: pos.x,
          top: pos.y,
          width: mapWidth,
          height: mapHeight,
          transform: `scale(${zoom})`,
          transformOrigin: "top left",
          zIndex: 99,
          pointerEvents: "none" // لضمان وصول الأحداث للـ SVG داخله
        }}
      >
        <div style={{ pointerEvents: "auto", width: "100%", height: "100%" }}>
          {!isOverlayHidden && (
            <UnitsSvg
              ref={unitsSvgRef}
              mapWidth={mapWidth}
              mapHeight={mapHeight}
              clickableLayer={clickableLayerSvgString}
              units={units}
              hoveredVilla={hoveredVilla}
              selectedVilla={selectedVilla}
              onMouseEnter={handleVillaMouseEnter}
              onMouseLeave={handleVillaMouseLeave}
              onVillaClick={handleVillaClick}
              activeTab={activeTab}
              cancelledTypes={filterSelection?.cancelledTypes || []}
              cancelledAvailability={filterSelection?.cancelledAvailability || []}
              progressCategories={filterSelection?.progressCategories || []}
              filters={filters}
            />
          )}
        </div>
      </div>

      {/* Selected villa card */}
      {selectedVilla && !isAnimating && (
        <div
          style={{
            position: "fixed",
            left: pos.x + selectedVilla.center.x * zoom * (mapWidth / viewBoxWidth),
            top: pos.y + selectedVilla.center.y * zoom * (mapHeight / viewBoxHeight),
            zIndex: 99999,
            transform: "translate(-50%, -110%)",
          }}
        >
          <VillaCard
            lang={lang}
            page="master-plan"
            width="340px"
            villa={selectedVilla}
            onShowProgress={setProgressVilla}
            onOpenModal={() => setSpinVilla(selectedVilla)}
          />
        </div>
      )}
    </div>
  );
}

function MasterPlane({ lang, filterSelection, isOverlayHidden, filters, setProgressVilla, setSpinVilla }) {
  return (
    <MasterPlaneInner
      filterSelection={filterSelection}
      isOverlayHidden={isOverlayHidden}
      filters={filters}
      lang={lang}
      setProgressVilla={setProgressVilla}
      setSpinVilla={setSpinVilla}
    />
  );
}

export default MasterPlane;